export const OneThousandActualWords = [
  {
    "word": "use",
    "word_context": "the key",
    "translat": "використовуй",
    "translat_context": "ключ",
    "dictionary": "використовувати",
    "lesson": "1"
  },
  {
    "word": "time",
    "word_context": "is precious",
    "translat": "час",
    "translat_context": "є цінним",
    "dictionary": "час",
    "lesson": "1"
  },
  {
    "word": "write",
    "word_context": "a message",
    "translat": "писати",
    "translat_context": "повідомлення",
    "dictionary": "писати",
    "lesson": "1"
  },
  {
    "word": "like",
    "word_context": "good music",
    "translat": "подобається",
    "translat_context": "гарна музика",
    "dictionary": "подобатися",
    "lesson": "1"
  },
  {
    "word": "long",
    "word_context": "journey",
    "translat": "довга",
    "translat_context": "подорож",
    "dictionary": "довгий",
    "lesson": "1"
  },
  {
    "word": "make",
    "word_context": "a cake",
    "translat": "робити",
    "translat_context": "торт",
    "dictionary": "робити",
    "lesson": "1"
  },
  {
    "word": "thing",
    "word_context": "of value",
    "translat": "річ",
    "translat_context": "цінна",
    "dictionary": "річ",
    "lesson": "1"
  },
  {
    "word": "see",
    "word_context": "the sunset",
    "translat": "бачити",
    "translat_context": "захід сонця",
    "dictionary": "бачити",
    "lesson": "1"
  },
  {
    "word": "look",
    "word_context": "at this",
    "translat": "дивись",
    "translat_context": "на це",
    "dictionary": "дивитися",
    "lesson": "1"
  },
  {
    "word": "day",
    "word_context": "off work",
    "translat": "день",
    "translat_context": "вихідний",
    "dictionary": "день",
    "lesson": "1"
  },
  {
    "word": "go",
    "word_context": "home now",
    "translat": "йти",
    "translat_context": "додому зараз",
    "dictionary": "йти",
    "lesson": "1"
  },
  {
    "word": "come",
    "word_context": "right away",
    "translat": "приходити",
    "translat_context": "негайно",
    "dictionary": "приходити",
    "lesson": "1"
  },
  {
    "word": "number",
    "word_context": "of students",
    "translat": "число",
    "translat_context": "студентів",
    "dictionary": "число",
    "lesson": "1"
  },
  {
    "word": "sound",
    "word_context": "of waves",
    "translat": "звук",
    "translat_context": "хвиль",
    "dictionary": "звук",
    "lesson": "1"
  },
  {
    "word": "people",
    "word_context": "are talking",
    "translat": "люди",
    "translat_context": "розмовляють",
    "dictionary": "люди",
    "lesson": "1"
  },
  {
    "word": "know",
    "word_context": "the truth",
    "translat": "знати",
    "translat_context": "правду",
    "dictionary": "знати",
    "lesson": "1"
  },
  {
    "word": "water",
    "word_context": "is cold",
    "translat": "вода",
    "translat_context": "холодна",
    "dictionary": "вода",
    "lesson": "1"
  },
  {
    "word": "call",
    "word_context": "your number",
    "translat": "дзвонити",
    "translat_context": "на твій номер",
    "dictionary": "дзвонити",
    "lesson": "1"
  },
  {
    "word": "side",
    "word_context": "of the road",
    "translat": "бік",
    "translat_context": "дороги",
    "dictionary": "бік",
    "lesson": "1"
  },
  {
    "word": "find",
    "word_context": "a way",
    "translat": "знайти",
    "translat_context": "шлях",
    "dictionary": "знайти",
    "lesson": "1"
  },
  {
    "word": "work",
    "word_context": "from home",
    "translat": "працювати",
    "translat_context": "з дому",
    "dictionary": "працювати",
    "lesson": "1"
  },
  {
    "word": "part",
    "word_context": "of life",
    "translat": "частина",
    "translat_context": "життя",
    "dictionary": "частина",
    "lesson": "1"
  },
  {
    "word": "take",
    "word_context": "a break",
    "translat": "взяти",
    "translat_context": "перерву",
    "dictionary": "взяти",
    "lesson": "1"
  },
  {
    "word": "get",
    "word_context": "some rest",
    "translat": "отримати",
    "translat_context": "відпочинок",
    "dictionary": "отримати",
    "lesson": "1"
  },
  {
    "word": "place",
    "word_context": "to stay",
    "translat": "місце",
    "translat_context": "де зупинитися",
    "dictionary": "місце",
    "lesson": "1"
  },
  {
    "word": "made",
    "word_context": "by hand",
    "translat": "зроблений",
    "translat_context": "вручну",
    "dictionary": "зроблений",
    "lesson": "1"
  },
  {
    "word": "live",
    "word_context": "in peace",
    "translat": "жити",
    "translat_context": "в мирі",
    "dictionary": "жити",
    "lesson": "1"
  },
  {
    "word": "round",
    "word_context": "table",
    "translat": "круглий",
    "translat_context": "стіл",
    "dictionary": "круглий",
    "lesson": "1"
  },
  {
    "word": "man",
    "word_context": "of honor",
    "translat": "чоловік",
    "translat_context": "честі",
    "dictionary": "чоловік",
    "lesson": "1"
  },
  {
    "word": "year",
    "word_context": "of change",
    "translat": "рік",
    "translat_context": "змін",
    "dictionary": "рік",
    "lesson": "1"
  },
  {
    "word": "came",
    "word_context": "too late",
    "translat": "прийшов",
    "translat_context": "запізно",
    "dictionary": "прийшов",
    "lesson": "1"
  },
  {
    "word": "show",
    "word_context": "some respect",
    "translat": "показати",
    "translat_context": "якусь повагу",
    "dictionary": "показати",
    "lesson": "1"
  },
  {
    "word": "every",
    "word_context": "time",
    "translat": "кожен",
    "translat_context": "раз",
    "dictionary": "кожен",
    "lesson": "1"
  },
  {
    "word": "good",
    "word_context": "result",
    "translat": "добрий",
    "translat_context": "результат",
    "dictionary": "добрий",
    "lesson": "1"
  },
  {
    "word": "give",
    "word_context": "a chance",
    "translat": "дати",
    "translat_context": "шанс",
    "dictionary": "дати",
    "lesson": "1"
  },
  {
    "word": "name",
    "word_context": "and age",
    "translat": "ім’я",
    "translat_context": "та вік",
    "dictionary": "ім’я",
    "lesson": "2"
  },
  {
    "word": "form",
    "word_context": "of art",
    "translat": "форма",
    "translat_context": "мистецтва",
    "dictionary": "форма",
    "lesson": "2"
  },
  {
    "word": "sentence",
    "word_context": "is long",
    "translat": "речення",
    "translat_context": "довге",
    "dictionary": "речення",
    "lesson": "2"
  },
  {
    "word": "great",
    "word_context": "job",
    "translat": "чудова",
    "translat_context": "робота",
    "dictionary": "чудова",
    "lesson": "2"
  },
  {
    "word": "think",
    "word_context": "about it",
    "translat": "думати",
    "translat_context": "про це",
    "dictionary": "думати",
    "lesson": "2"
  },
  {
    "word": "say",
    "word_context": "the truth",
    "translat": "сказати",
    "translat_context": "правду",
    "dictionary": "сказати",
    "lesson": "2"
  },
  {
    "word": "help",
    "word_context": "a friend",
    "translat": "допомагати",
    "translat_context": "другу",
    "dictionary": "допомагати",
    "lesson": "2"
  },
  {
    "word": "low",
    "word_context": "price",
    "translat": "низька",
    "translat_context": "ціна",
    "dictionary": "низький",
    "lesson": "2"
  },
  {
    "word": "line",
    "word_context": "of code",
    "translat": "рядок",
    "translat_context": "коду",
    "dictionary": "рядок",
    "lesson": "2"
  },
  {
    "word": "differ",
    "word_context": "in meaning",
    "translat": "відрізнятись",
    "translat_context": "за значенням",
    "dictionary": "відрізнятись",
    "lesson": "2"
  },
  {
    "word": "turn",
    "word_context": "the page",
    "translat": "перегорни",
    "translat_context": "сторінку",
    "dictionary": "перегорнути",
    "lesson": "2"
  },
  {
    "word": "cause",
    "word_context": "a problem",
    "translat": "спричинити",
    "translat_context": "проблему",
    "dictionary": "спричинити",
    "lesson": "2"
  },
  {
    "word": "mean",
    "word_context": "no harm",
    "translat": "мати на увазі",
    "translat_context": "нічого поганого",
    "dictionary": "мати на увазі",
    "lesson": "2"
  },
  {
    "word": "move",
    "word_context": "forward",
    "translat": "рухатись",
    "translat_context": "вперед",
    "dictionary": "рухатись",
    "lesson": "2"
  },
  {
    "word": "right",
    "word_context": "answer",
    "translat": "правильна",
    "translat_context": "відповідь",
    "dictionary": "правильний",
    "lesson": "2"
  },
  {
    "word": "boy",
    "word_context": "next door",
    "translat": "хлопець",
    "translat_context": "по сусідству",
    "dictionary": "хлопець",
    "lesson": "2"
  },
  {
    "word": "old",
    "word_context": "friend",
    "translat": "старий",
    "translat_context": "друг",
    "dictionary": "старий",
    "lesson": "2"
  },
  {
    "word": "same",
    "word_context": "idea",
    "translat": "та сама",
    "translat_context": "ідея",
    "dictionary": "та сама",
    "lesson": "2"
  },
  {
    "word": "tell",
    "word_context": "the story",
    "translat": "розповісти",
    "translat_context": "історію",
    "dictionary": "розповісти",
    "lesson": "2"
  },
  {
    "word": "set",
    "word_context": "the table",
    "translat": "накрити",
    "translat_context": "стіл",
    "dictionary": "накрити",
    "lesson": "2"
  },
  {
    "word": "want",
    "word_context": "some rest",
    "translat": "хотіти",
    "translat_context": "відпочинку",
    "dictionary": "хотіти",
    "lesson": "2"
  },
  {
    "word": "air",
    "word_context": "is fresh",
    "translat": "повітря",
    "translat_context": "свіже",
    "dictionary": "повітря",
    "lesson": "2"
  },
  {
    "word": "well",
    "word_context": "done",
    "translat": "добре",
    "translat_context": "зроблено",
    "dictionary": "добре",
    "lesson": "2"
  },
  {
    "word": "play",
    "word_context": "a game",
    "translat": "грати",
    "translat_context": "гру",
    "dictionary": "грати",
    "lesson": "2"
  },
  {
    "word": "small",
    "word_context": "town",
    "translat": "маленьке",
    "translat_context": "містечко",
    "dictionary": "маленький",
    "lesson": "2"
  },
  {
    "word": "end",
    "word_context": "of day",
    "translat": "кінець",
    "translat_context": "дня",
    "dictionary": "кінець",
    "lesson": "2"
  },
  {
    "word": "put",
    "word_context": "it back",
    "translat": "поклади",
    "translat_context": "назад",
    "dictionary": "класти",
    "lesson": "2"
  },
  {
    "word": "home",
    "word_context": "sweet home",
    "translat": "дім",
    "translat_context": "рідний дім",
    "dictionary": "дім",
    "lesson": "2"
  },
  {
    "word": "read",
    "word_context": "a book",
    "translat": "читати",
    "translat_context": "книгу",
    "dictionary": "читати",
    "lesson": "2"
  },
  {
    "word": "hand",
    "word_context": "in hand",
    "translat": "рука",
    "translat_context": "об руку",
    "dictionary": "рука",
    "lesson": "2"
  },
  {
    "word": "port",
    "word_context": "of entry",
    "translat": "порт",
    "translat_context": "в'їзду",
    "dictionary": "порт",
    "lesson": "2"
  },
  {
    "word": "large",
    "word_context": "city",
    "translat": "велике",
    "translat_context": "місто",
    "dictionary": "великий",
    "lesson": "2"
  },
  {
    "word": "spell",
    "word_context": "the word",
    "translat": "вимовити",
    "translat_context": "слово по буквам",
    "dictionary": "вимовити",
    "lesson": "2"
  },
  {
    "word": "add",
    "word_context": "a comment",
    "translat": "додати",
    "translat_context": "коментар",
    "dictionary": "додати",
    "lesson": "2"
  },
  {
    "word": "land",
    "word_context": "of dreams",
    "translat": "земля",
    "translat_context": "мрій",
    "dictionary": "земля",
    "lesson": "2"
  },
  {
    "word": "big",
    "word_context": "opportunity",
    "translat": "велика",
    "translat_context": "можливість",
    "dictionary": "великий",
    "lesson": "3"
  },
  {
    "word": "high",
    "word_context": "hopes",
    "translat": "високі",
    "translat_context": "надії",
    "dictionary": "високі",
    "lesson": "3"
  },
  {
    "word": "follow",
    "word_context": "the leader",
    "translat": "слідуй",
    "translat_context": "за лідером",
    "dictionary": "слідувати",
    "lesson": "3"
  },
  {
    "word": "act",
    "word_context": "of kindness",
    "translat": "вчинок",
    "translat_context": "доброти",
    "dictionary": "вчинок",
    "lesson": "3"
  },
  {
    "word": "ask",
    "word_context": "a question",
    "translat": "запитати",
    "translat_context": "питання",
    "dictionary": "запитати",
    "lesson": "3"
  },
  {
    "word": "men",
    "word_context": "at work",
    "translat": "чоловіки",
    "translat_context": "на роботі",
    "dictionary": "чоловіки",
    "lesson": "3"
  },
  {
    "word": "change",
    "word_context": "your mind",
    "translat": "змінити",
    "translat_context": "думку",
    "dictionary": "змінити",
    "lesson": "3"
  },
  {
    "word": "went",
    "word_context": "to school",
    "translat": "пішов",
    "translat_context": "до школи",
    "dictionary": "пішов",
    "lesson": "3"
  },
  {
    "word": "light",
    "word_context": "a candle",
    "translat": "запалити",
    "translat_context": "свічку",
    "dictionary": "запалити",
    "lesson": "3"
  },
  {
    "word": "kind",
    "word_context": "gesture",
    "translat": "добрий",
    "translat_context": "вчинок",
    "dictionary": "добрий",
    "lesson": "3"
  },
  {
    "word": "need",
    "word_context": "some help",
    "translat": "потребувати",
    "translat_context": "допомоги",
    "dictionary": "потребувати",
    "lesson": "3"
  },
  {
    "word": "house",
    "word_context": "on the hill",
    "translat": "будинок",
    "translat_context": "на пагорбі",
    "dictionary": "будинок",
    "lesson": "3"
  },
  {
    "word": "picture",
    "word_context": "of the sea",
    "translat": "зображення",
    "translat_context": "моря",
    "dictionary": "зображення",
    "lesson": "3"
  },
  {
    "word": "try",
    "word_context": "again",
    "translat": "спробуй",
    "translat_context": "ще раз",
    "dictionary": "спробувати",
    "lesson": "3"
  },
  {
    "word": "animal",
    "word_context": "kingdom",
    "translat": "тваринне",
    "translat_context": "царство",
    "dictionary": "тварина",
    "lesson": "3"
  },
  {
    "word": "point",
    "word_context": "of view",
    "translat": "точка",
    "translat_context": "зору",
    "dictionary": "точка",
    "lesson": "3"
  },
  {
    "word": "mother",
    "word_context": "and child",
    "translat": "мати",
    "translat_context": "й дитина",
    "dictionary": "мати",
    "lesson": "3"
  },
  {
    "word": "world",
    "word_context": "economy",
    "translat": "світова",
    "translat_context": "економіка",
    "dictionary": "світова",
    "lesson": "3"
  },
  {
    "word": "near",
    "word_context": "the river",
    "translat": "поблизу",
    "translat_context": "ріки",
    "dictionary": "поблизу",
    "lesson": "3"
  },
  {
    "word": "build",
    "word_context": "a bridge",
    "translat": "будувати",
    "translat_context": "міст",
    "dictionary": "будувати",
    "lesson": "3"
  },
  {
    "word": "earth",
    "word_context": "is round",
    "translat": "земля",
    "translat_context": "кругла",
    "dictionary": "земля",
    "lesson": "3"
  },
  {
    "word": "father",
    "word_context": "and son",
    "translat": "батько",
    "translat_context": "і син",
    "dictionary": "батько",
    "lesson": "3"
  },
  {
    "word": "head",
    "word_context": "of state",
    "translat": "глава",
    "translat_context": "держави",
    "dictionary": "глава",
    "lesson": "3"
  },
  {
    "word": "stand",
    "word_context": "still",
    "translat": "стояти",
    "translat_context": "спокійно",
    "dictionary": "стояти",
    "lesson": "3"
  },
  {
    "word": "page",
    "word_context": "number two",
    "translat": "сторінка",
    "translat_context": "номер два",
    "dictionary": "сторінка",
    "lesson": "3"
  },
  {
    "word": "country",
    "word_context": "of birth",
    "translat": "країна",
    "translat_context": "народження",
    "dictionary": "країна",
    "lesson": "3"
  },
  {
    "word": "found",
    "word_context": "the key",
    "translat": "знайшов",
    "translat_context": "ключ",
    "dictionary": "знайшов",
    "lesson": "3"
  },
  {
    "word": "answer",
    "word_context": "is clear",
    "translat": "відповідь",
    "translat_context": "очевидна",
    "dictionary": "відповідь",
    "lesson": "3"
  },
  {
    "word": "school",
    "word_context": "project",
    "translat": "шкільний",
    "translat_context": "проєкт",
    "dictionary": "шкільний",
    "lesson": "3"
  },
  {
    "word": "grow",
    "word_context": "a plant",
    "translat": "вирощувати",
    "translat_context": "рослину",
    "dictionary": "вирощувати",
    "lesson": "3"
  },
  {
    "word": "study",
    "word_context": "hard",
    "translat": "навчатися",
    "translat_context": "наполегливо (важко)",
    "dictionary": "навчатися",
    "lesson": "3"
  },
  {
    "word": "learn",
    "word_context": "new skills",
    "translat": "вивчати",
    "translat_context": "нові навички",
    "dictionary": "вивчати",
    "lesson": "3"
  },
  {
    "word": "plant",
    "word_context": "a seed",
    "translat": "посадити",
    "translat_context": "насіння",
    "dictionary": "посадити",
    "lesson": "3"
  },
  {
    "word": "cover",
    "word_context": "the table",
    "translat": "накрити",
    "translat_context": "стіл",
    "dictionary": "накрити",
    "lesson": "3"
  },
  {
    "word": "food",
    "word_context": "is ready",
    "translat": "їжа",
    "translat_context": "готова",
    "dictionary": "їжа",
    "lesson": "3"
  },
  {
    "word": "sun",
    "word_context": "is shining",
    "translat": "сонце",
    "translat_context": "світить",
    "dictionary": "сонце",
    "lesson": "4"
  },
  {
    "word": "between",
    "word_context": "two options",
    "translat": "між",
    "translat_context": "двома варіантами",
    "dictionary": "між",
    "lesson": "4"
  },
  {
    "word": "state",
    "word_context": "of mind",
    "translat": "стан",
    "translat_context": "розуму",
    "dictionary": "стан",
    "lesson": "4"
  },
  {
    "word": "keep",
    "word_context": "a secret",
    "translat": "зберігати",
    "translat_context": "таємницю",
    "dictionary": "зберігати",
    "lesson": "4"
  },
  {
    "word": "eye",
    "word_context": "of the tiger",
    "translat": "око",
    "translat_context": "тигра",
    "dictionary": "око",
    "lesson": "4"
  },
  {
    "word": "last",
    "word_context": "chance",
    "translat": "останній",
    "translat_context": "шанс",
    "dictionary": "останній",
    "lesson": "4"
  },
  {
    "word": "thought",
    "word_context": "of the day",
    "translat": "думка",
    "translat_context": "дня",
    "dictionary": "думка",
    "lesson": "4"
  },
  {
    "word": "city",
    "word_context": "life",
    "translat": "міське",
    "translat_context": "життя",
    "dictionary": "міське",
    "lesson": "4"
  },
  {
    "word": "tree",
    "word_context": "is tall",
    "translat": "дерево",
    "translat_context": "високе",
    "dictionary": "дерево",
    "lesson": "4"
  },
  {
    "word": "cross",
    "word_context": "is red",
    "translat": "хрест",
    "translat_context": "червоний",
    "dictionary": "хрест",
    "lesson": "4"
  },
  {
    "word": "farm",
    "word_context": "for sheep",
    "translat": "ферма",
    "translat_context": "для овець",
    "dictionary": "ферма",
    "lesson": "4"
  },
  {
    "word": "hard",
    "word_context": "task",
    "translat": "важке",
    "translat_context": "завдання",
    "dictionary": "важке",
    "lesson": "4"
  },
  {
    "word": "start",
    "word_context": "again",
    "translat": "почати",
    "translat_context": "знову",
    "dictionary": "почати",
    "lesson": "4"
  },
  {
    "word": "story",
    "word_context": "of my life",
    "translat": "історія",
    "translat_context": "мого життя",
    "dictionary": "історія",
    "lesson": "4"
  },
  {
    "word": "saw",
    "word_context": "a bird",
    "translat": "побачив",
    "translat_context": "пташку",
    "dictionary": "побачив",
    "lesson": "4"
  },
  {
    "word": "far",
    "word_context": "away",
    "translat": "далеко",
    "translat_context": "відсюди",
    "dictionary": "далеко",
    "lesson": "4"
  },
  {
    "word": "sea",
    "word_context": "of doubts",
    "translat": "море",
    "translat_context": "сумнівів",
    "dictionary": "море",
    "lesson": "4"
  },
  {
    "word": "draw",
    "word_context": "a picture",
    "translat": "намалювати",
    "translat_context": "малюнок",
    "dictionary": "намалювати",
    "lesson": "4"
  },
  {
    "word": "left",
    "word_context": "turn",
    "translat": "лівий",
    "translat_context": "поворот",
    "dictionary": "лівий",
    "lesson": "4"
  },
  {
    "word": "late",
    "word_context": "arrival",
    "translat": "пізнє",
    "translat_context": "прибуття",
    "dictionary": "пізнє",
    "lesson": "4"
  },
  {
    "word": "run",
    "word_context": "fast",
    "translat": "бігти",
    "translat_context": "швидко",
    "dictionary": "бігти",
    "lesson": "4"
  },
  {
    "word": "press",
    "word_context": "the button",
    "translat": "натисни",
    "translat_context": "кнопку",
    "dictionary": "натисни",
    "lesson": "4"
  },
  {
    "word": "close",
    "word_context": "the door",
    "translat": "закрий",
    "translat_context": "двері",
    "dictionary": "закрий",
    "lesson": "4"
  },
  {
    "word": "night",
    "word_context": "sky",
    "translat": "нічне",
    "translat_context": "небо",
    "dictionary": "нічне",
    "lesson": "4"
  },
  {
    "word": "real",
    "word_context": "problem",
    "translat": "реальна",
    "translat_context": "проблема",
    "dictionary": "реальна",
    "lesson": "4"
  },
  {
    "word": "life",
    "word_context": "lessons",
    "translat": "життєві",
    "translat_context": "уроки",
    "dictionary": "життєві",
    "lesson": "4"
  },
  {
    "word": "north",
    "word_context": "wind",
    "translat": "північний",
    "translat_context": "вітер",
    "dictionary": "північний",
    "lesson": "4"
  },
  {
    "word": "open",
    "word_context": "the window",
    "translat": "відкрити",
    "translat_context": "вікно",
    "dictionary": "відкрити",
    "lesson": "4"
  },
  {
    "word": "seem",
    "word_context": "strange",
    "translat": "здаватися",
    "translat_context": "дивним",
    "dictionary": "здаватися",
    "lesson": "4"
  },
  {
    "word": "together",
    "word_context": "again",
    "translat": "разом",
    "translat_context": "знову",
    "dictionary": "разом",
    "lesson": "4"
  },
  {
    "word": "white",
    "word_context": "shirt",
    "translat": "біла",
    "translat_context": "сорочка",
    "dictionary": "біла",
    "lesson": "4"
  },
  {
    "word": "children",
    "word_context": "are playing",
    "translat": "діти",
    "translat_context": "граються",
    "dictionary": "діти",
    "lesson": "4"
  },
  {
    "word": "begin",
    "word_context": "now",
    "translat": "почати",
    "translat_context": "зараз",
    "dictionary": "почати",
    "lesson": "4"
  },
  {
    "word": "got",
    "word_context": "the job",
    "translat": "отримав",
    "translat_context": "роботу",
    "dictionary": "отримав",
    "lesson": "4"
  },
  {
    "word": "walk",
    "word_context": "slowly",
    "translat": "йти",
    "translat_context": "повільно",
    "dictionary": "йти",
    "lesson": "4"
  },
  {
    "word": "example",
    "word_context": "given",
    "translat": "приклад",
    "translat_context": "наведений",
    "dictionary": "приклад",
    "lesson": "5"
  },
  {
    "word": "ease",
    "word_context": "of use",
    "translat": "простота",
    "translat_context": "використання",
    "dictionary": "простота",
    "lesson": "5"
  },
  {
    "word": "paper",
    "word_context": "sheet",
    "translat": "паперу",
    "translat_context": "аркуш",
    "dictionary": "паперу",
    "lesson": "5"
  },
  {
    "word": "group",
    "word_context": "of friends",
    "translat": "група",
    "translat_context": "друзів",
    "dictionary": "група",
    "lesson": "5"
  },
  {
    "word": "always",
    "word_context": "on time",
    "translat": "завжди",
    "translat_context": "вчасно",
    "dictionary": "завжди",
    "lesson": "5"
  },
  {
    "word": "music",
    "word_context": "is loud",
    "translat": "музика",
    "translat_context": "гучна",
    "dictionary": "музика",
    "lesson": "5"
  },
  {
    "word": "mark",
    "word_context": "the spot",
    "translat": "відмітити",
    "translat_context": "місце",
    "dictionary": "відмітити",
    "lesson": "5"
  },
  {
    "word": "letter",
    "word_context": "from mom",
    "translat": "лист",
    "translat_context": "від мами",
    "dictionary": "лист",
    "lesson": "5"
  },
  {
    "word": "mile",
    "word_context": "ahead",
    "translat": "миля",
    "translat_context": "вперед",
    "dictionary": "миля",
    "lesson": "5"
  },
  {
    "word": "river",
    "word_context": "Thames",
    "translat": "річка",
    "translat_context": "Темза",
    "dictionary": "річка",
    "lesson": "5"
  },
  {
    "word": "car",
    "word_context": "is blue",
    "translat": "машина",
    "translat_context": "синя",
    "dictionary": "машина",
    "lesson": "5"
  },
  {
    "word": "feet",
    "word_context": "are tired",
    "translat": "ноги",
    "translat_context": "втомлені",
    "dictionary": "ноги",
    "lesson": "5"
  },
  {
    "word": "care",
    "word_context": "deeply",
    "translat": "піклуватися",
    "translat_context": "глибоко",
    "dictionary": "піклуватися",
    "lesson": "5"
  },
  {
    "word": "book",
    "word_context": "to read",
    "translat": "книга",
    "translat_context": "для читання",
    "dictionary": "книга",
    "lesson": "5"
  },
  {
    "word": "carry",
    "word_context": "a bag",
    "translat": "нести",
    "translat_context": "сумку",
    "dictionary": "нести",
    "lesson": "5"
  },
  {
    "word": "took",
    "word_context": "a book",
    "translat": "взяв",
    "translat_context": "книгу",
    "dictionary": "взяв",
    "lesson": "5"
  },
  {
    "word": "science",
    "word_context": "is fun",
    "translat": "наука",
    "translat_context": "це весело",
    "dictionary": "наука",
    "lesson": "5"
  },
  {
    "word": "eat",
    "word_context": "dinner",
    "translat": "їсти",
    "translat_context": "вечерю",
    "dictionary": "їсти",
    "lesson": "5"
  },
  {
    "word": "room",
    "word_context": "is clean",
    "translat": "кімната",
    "translat_context": "чиста",
    "dictionary": "кімната",
    "lesson": "5"
  },
  {
    "word": "friend",
    "word_context": "forever",
    "translat": "друг",
    "translat_context": "назавжди",
    "dictionary": "друг",
    "lesson": "5"
  },
  {
    "word": "began",
    "word_context": "to rain",
    "translat": "почало",
    "translat_context": "дощити",
    "dictionary": "почало",
    "lesson": "5"
  },
  {
    "word": "idea",
    "word_context": "was great",
    "translat": "ідея",
    "translat_context": "була чудовою",
    "dictionary": "ідея",
    "lesson": "5"
  },
  {
    "word": "fish",
    "word_context": "is swimming",
    "translat": "риба",
    "translat_context": "плаває",
    "dictionary": "риба",
    "lesson": "5"
  },
  {
    "word": "mountain",
    "word_context": "is high",
    "translat": "гора",
    "translat_context": "висока",
    "dictionary": "гора",
    "lesson": "5"
  },
  {
    "word": "stop",
    "word_context": "here",
    "translat": "зупинись",
    "translat_context": "тут",
    "dictionary": "зупинись",
    "lesson": "5"
  },
  {
    "word": "base",
    "word_context": "camp",
    "translat": "базовий",
    "translat_context": "табір",
    "dictionary": "базовий",
    "lesson": "5"
  },
  {
    "word": "hear",
    "word_context": "the noise",
    "translat": "чути",
    "translat_context": "шум",
    "dictionary": "чути",
    "lesson": "5"
  },
  {
    "word": "horse",
    "word_context": "is fast",
    "translat": "кінь",
    "translat_context": "",
    "dictionary": "кінь",
    "lesson": "5"
  },
  {
    "word": "cut",
    "word_context": "the paper",
    "translat": "різати",
    "translat_context": "папір",
    "dictionary": "різати",
    "lesson": "5"
  },
  {
    "word": "sure",
    "word_context": "thing",
    "translat": "напевна",
    "translat_context": "річ",
    "dictionary": "напевна",
    "lesson": "5"
  },
  {
    "word": "watch",
    "word_context": "TV",
    "translat": "дивитись",
    "translat_context": "телевізор",
    "dictionary": "дивитись",
    "lesson": "5"
  },
  {
    "word": "color",
    "word_context": "is blue",
    "translat": "колір",
    "translat_context": "синій",
    "dictionary": "колір",
    "lesson": "5"
  },
  {
    "word": "face",
    "word_context": "to face",
    "translat": "обличчя",
    "translat_context": "в обличчя",
    "dictionary": "обличчя",
    "lesson": "5"
  },
  {
    "word": "wood",
    "word_context": "floor",
    "translat": "дерев’яна",
    "translat_context": "підлога",
    "dictionary": "дерев’яна",
    "lesson": "5"
  },
  {
    "word": "main",
    "word_context": "road",
    "translat": "головна",
    "translat_context": "дорога",
    "dictionary": "головна",
    "lesson": "5"
  },
  {
    "word": "enough",
    "word_context": "space",
    "translat": "достатньо",
    "translat_context": "місця",
    "dictionary": "достатньо",
    "lesson": "6"
  },
  {
    "word": "plain",
    "word_context": "truth",
    "translat": "проста",
    "translat_context": "правда",
    "dictionary": "проста",
    "lesson": "6"
  },
  {
    "word": "girl",
    "word_context": "next door",
    "translat": "дівчина",
    "translat_context": "по сусідству",
    "dictionary": "дівчина",
    "lesson": "6"
  },
  {
    "word": "usual",
    "word_context": "routine",
    "translat": "звичайна",
    "translat_context": "рутина",
    "dictionary": "звичайна",
    "lesson": "6"
  },
  {
    "word": "young",
    "word_context": "man",
    "translat": "молодий",
    "translat_context": "чоловік",
    "dictionary": "молодий",
    "lesson": "6"
  },
  {
    "word": "ready",
    "word_context": "to go",
    "translat": "готовий",
    "translat_context": "йти",
    "dictionary": "готовий",
    "lesson": "6"
  },
  {
    "word": "above",
    "word_context": "the clouds",
    "translat": "над",
    "translat_context": "хмарами",
    "dictionary": "над",
    "lesson": "6"
  },
  {
    "word": "ever",
    "word_context": "since then",
    "translat": "завжди",
    "translat_context": "відтоді",
    "dictionary": "завжди",
    "lesson": "6"
  },
  {
    "word": "red",
    "word_context": "apple",
    "translat": "червоне",
    "translat_context": "яблуко",
    "dictionary": "червоне",
    "lesson": "6"
  },
  {
    "word": "list",
    "word_context": "of items",
    "translat": "список",
    "translat_context": "речей",
    "dictionary": "список",
    "lesson": "6"
  },
  {
    "word": "feel",
    "word_context": "happy",
    "translat": "відчувати",
    "translat_context": "радість",
    "dictionary": "відчувати",
    "lesson": "6"
  },
  {
    "word": "talk",
    "word_context": "later",
    "translat": "поговоримо",
    "translat_context": "пізніше",
    "dictionary": "поговоримо",
    "lesson": "6"
  },
  {
    "word": "bird",
    "word_context": "is singing",
    "translat": "пташка",
    "translat_context": "співає",
    "dictionary": "пташка",
    "lesson": "6"
  },
  {
    "word": "soon",
    "word_context": "enough",
    "translat": "скоро",
    "translat_context": "достатньо",
    "dictionary": "скоро",
    "lesson": "6"
  },
  {
    "word": "body",
    "word_context": "language",
    "translat": "тіла",
    "translat_context": "мова",
    "dictionary": "тіла",
    "lesson": "6"
  },
  {
    "word": "dog",
    "word_context": "is barking",
    "translat": "собака",
    "translat_context": "гавкає",
    "dictionary": "собака",
    "lesson": "6"
  },
  {
    "word": "family",
    "word_context": "dinner",
    "translat": "сімейна",
    "translat_context": "вечеря",
    "dictionary": "сімейна",
    "lesson": "6"
  },
  {
    "word": "direct",
    "word_context": "route",
    "translat": "прямий",
    "translat_context": "маршрут",
    "dictionary": "прямий",
    "lesson": "6"
  },
  {
    "word": "pose",
    "word_context": "a threat",
    "translat": "становити",
    "translat_context": "загрозу",
    "dictionary": "становити",
    "lesson": "6"
  },
  {
    "word": "leave",
    "word_context": "now",
    "translat": "залишити",
    "translat_context": "зараз",
    "dictionary": "залишити",
    "lesson": "6"
  },
  {
    "word": "song",
    "word_context": "is beautiful",
    "translat": "пісня",
    "translat_context": "гарна",
    "dictionary": "пісня",
    "lesson": "6"
  },
  {
    "word": "measure",
    "word_context": "distance",
    "translat": "вимірювати",
    "translat_context": "відстань",
    "dictionary": "вимірювати",
    "lesson": "6"
  },
  {
    "word": "door",
    "word_context": "is open",
    "translat": "двері",
    "translat_context": "відкриті",
    "dictionary": "двері",
    "lesson": "6"
  },
  {
    "word": "product",
    "word_context": "launch",
    "translat": "продукту",
    "translat_context": "запуск",
    "dictionary": "продукту",
    "lesson": "6"
  },
  {
    "word": "black",
    "word_context": "coffee",
    "translat": "чорна",
    "translat_context": "кава",
    "dictionary": "чорна",
    "lesson": "6"
  },
  {
    "word": "short",
    "word_context": "story",
    "translat": "коротка",
    "translat_context": "історія",
    "dictionary": "короткий",
    "lesson": "6"
  },
  {
    "word": "class",
    "word_context": "is starting",
    "translat": "заняття",
    "translat_context": "починається",
    "dictionary": "заняття",
    "lesson": "6"
  },
  {
    "word": "wind",
    "word_context": "is strong",
    "translat": "вітер",
    "translat_context": "сильний",
    "dictionary": "вітер",
    "lesson": "6"
  },
  {
    "word": "question",
    "word_context": "was difficult",
    "translat": "питання",
    "translat_context": "було складне",
    "dictionary": "питання",
    "lesson": "6"
  },
  {
    "word": "happen",
    "word_context": "by accident",
    "translat": "трапитися",
    "translat_context": "випадково",
    "dictionary": "трапитися",
    "lesson": "6"
  },
  {
    "word": "complete",
    "word_context": "the task",
    "translat": "завершити",
    "translat_context": "завдання",
    "dictionary": "завершити",
    "lesson": "6"
  },
  {
    "word": "ship",
    "word_context": "in harbor",
    "translat": "корабель",
    "translat_context": "в гавані",
    "dictionary": "корабель",
    "lesson": "6"
  },
  {
    "word": "area",
    "word_context": "is clean",
    "translat": "зона",
    "translat_context": "чиста",
    "dictionary": "зона",
    "lesson": "6"
  },
  {
    "word": "half",
    "word_context": "a sandwich",
    "translat": "половина",
    "translat_context": "бутерброда",
    "dictionary": "половина",
    "lesson": "6"
  },
  {
    "word": "rock",
    "word_context": "is big",
    "translat": "камінь",
    "translat_context": "великий",
    "dictionary": "камінь",
    "lesson": "6"
  },
  {
    "word": "order",
    "word_context": "was placed",
    "translat": "замовлення",
    "translat_context": "розміщено",
    "dictionary": "замовлення",
    "lesson": "7"
  },
  {
    "word": "fire",
    "word_context": "is hot",
    "translat": "вогонь",
    "translat_context": "гарячий",
    "dictionary": "вогонь",
    "lesson": "7"
  },
  {
    "word": "south",
    "word_context": "region",
    "translat": "південний",
    "translat_context": "регіон",
    "dictionary": "південний",
    "lesson": "7"
  },
  {
    "word": "problem",
    "word_context": "solved",
    "translat": "проблема",
    "translat_context": "вирішена",
    "dictionary": "проблема",
    "lesson": "7"
  },
  {
    "word": "piece",
    "word_context": "of cake",
    "translat": "шматок",
    "translat_context": "торта",
    "dictionary": "шматок",
    "lesson": "7"
  },
  {
    "word": "told",
    "word_context": "the truth",
    "translat": "сказав",
    "translat_context": "правду",
    "dictionary": "сказав",
    "lesson": "7"
  },
  {
    "word": "knew",
    "word_context": "his name",
    "translat": "знав",
    "translat_context": "його ім’я",
    "dictionary": "знав",
    "lesson": "7"
  },
  {
    "word": "pass",
    "word_context": "the ball",
    "translat": "передай",
    "translat_context": "м'яч",
    "dictionary": "передай",
    "lesson": "7"
  },
  {
    "word": "top",
    "word_context": "shelf",
    "translat": "верхня",
    "translat_context": "полиця",
    "dictionary": "верхній",
    "lesson": "7"
  },
  {
    "word": "whole",
    "word_context": "thing",
    "translat": "вся",
    "translat_context": "річ",
    "dictionary": "весь",
    "lesson": "7"
  },
  {
    "word": "king",
    "word_context": "and queen",
    "translat": "король",
    "translat_context": "і королева",
    "dictionary": "король",
    "lesson": "7"
  },
  {
    "word": "space",
    "word_context": "mission",
    "translat": "космічна",
    "translat_context": "місія",
    "dictionary": "космос",
    "lesson": "7"
  },
  {
    "word": "heard",
    "word_context": "a whisper",
    "translat": "почув",
    "translat_context": "шепіт",
    "dictionary": "почув",
    "lesson": "7"
  },
  {
    "word": "best",
    "word_context": "result",
    "translat": "найкращий",
    "translat_context": "результат",
    "dictionary": "найкращий",
    "lesson": "7"
  },
  {
    "word": "hour",
    "word_context": "passed",
    "translat": "година",
    "translat_context": "минула",
    "dictionary": "година",
    "lesson": "7"
  },
  {
    "word": "better",
    "word_context": "choice",
    "translat": "кращий",
    "translat_context": "вибір",
    "dictionary": "кращий",
    "lesson": "7"
  },
  {
    "word": "true",
    "word_context": "story",
    "translat": "правдива",
    "translat_context": "історія",
    "dictionary": "правдивий",
    "lesson": "7"
  },
  {
    "word": "remember",
    "word_context": "this day",
    "translat": "пам’ятай",
    "translat_context": "цей день",
    "dictionary": "пам’ятати",
    "lesson": "7"
  },
  {
    "word": "step",
    "word_context": "forward",
    "translat": "крок",
    "translat_context": "вперед",
    "dictionary": "крок",
    "lesson": "7"
  },
  {
    "word": "early",
    "word_context": "morning",
    "translat": "ранній",
    "translat_context": "ранок",
    "dictionary": "ранній",
    "lesson": "7"
  },
  {
    "word": "hold",
    "word_context": "my hand",
    "translat": "тримай",
    "translat_context": "мою руку",
    "dictionary": "тримати",
    "lesson": "7"
  },
  {
    "word": "west",
    "word_context": "wind",
    "translat": "західний",
    "translat_context": "вітер",
    "dictionary": "західний",
    "lesson": "7"
  },
  {
    "word": "ground",
    "word_context": "is wet",
    "translat": "земля",
    "translat_context": "мокра",
    "dictionary": "земля",
    "lesson": "7"
  },
  {
    "word": "interest",
    "word_context": "grows",
    "translat": "інтерес",
    "translat_context": "зростає",
    "dictionary": "інтерес",
    "lesson": "7"
  },
  {
    "word": "reach",
    "word_context": "the top",
    "translat": "досягти",
    "translat_context": "вершини",
    "dictionary": "досягти",
    "lesson": "7"
  },
  {
    "word": "verb",
    "word_context": "form",
    "translat": "дієслова",
    "translat_context": "форма",
    "dictionary": "дієслово",
    "lesson": "7"
  },
  {
    "word": "sing",
    "word_context": "a song",
    "translat": "співати",
    "translat_context": "пісню",
    "dictionary": "співати",
    "lesson": "7"
  },
  {
    "word": "listen",
    "word_context": "carefully",
    "translat": "слухай",
    "translat_context": "уважно",
    "dictionary": "слухай",
    "lesson": "7"
  },
  {
    "word": "table",
    "word_context": "is set",
    "translat": "стіл",
    "translat_context": "накритий",
    "dictionary": "стіл",
    "lesson": "7"
  },
  {
    "word": "travel",
    "word_context": "light",
    "translat": "подорожувати",
    "translat_context": "легко",
    "dictionary": "подорожувати",
    "lesson": "7"
  },
  {
    "word": "less",
    "word_context": "is more",
    "translat": "менше",
    "translat_context": "це більше",
    "dictionary": "менше",
    "lesson": "7"
  },
  {
    "word": "morning",
    "word_context": "news",
    "translat": "ранкові",
    "translat_context": "новини",
    "dictionary": "ранковий",
    "lesson": "7"
  },
  {
    "word": "simple",
    "word_context": "idea",
    "translat": "проста",
    "translat_context": "ідея",
    "dictionary": "простий",
    "lesson": "7"
  },
  {
    "word": "several",
    "word_context": "chances",
    "translat": "кілька",
    "translat_context": "шансів",
    "dictionary": "кілька",
    "lesson": "7"
  },
  {
    "word": "beautiful",
    "word_context": "garden",
    "translat": "гарний",
    "translat_context": "сад",
    "dictionary": "гарний",
    "lesson": "7"
  },
  {
    "word": "toward",
    "word_context": "the light",
    "translat": "до",
    "translat_context": "світла",
    "dictionary": "до",
    "lesson": "8"
  },
  {
    "word": "war",
    "word_context": "ended",
    "translat": "війна",
    "translat_context": "завершилася",
    "dictionary": "війна",
    "lesson": "8"
  },
  {
    "word": "lay",
    "word_context": "low",
    "translat": "лежати",
    "translat_context": "низько",
    "dictionary": "лежати",
    "lesson": "8"
  },
  {
    "word": "busy",
    "word_context": "line",
    "translat": "зайнята",
    "translat_context": "лінія",
    "dictionary": "зайнятий",
    "lesson": "8"
  },
  {
    "word": "slow",
    "word_context": "movement",
    "translat": "повільний",
    "translat_context": "рух",
    "dictionary": "повільний",
    "lesson": "8"
  },
  {
    "word": "center",
    "word_context": "of city",
    "translat": "центр",
    "translat_context": "міста",
    "dictionary": "центр",
    "lesson": "8"
  },
  {
    "word": "love",
    "word_context": "deeply",
    "translat": "любити",
    "translat_context": "глибоко",
    "dictionary": "любити",
    "lesson": "8"
  },
  {
    "word": "person",
    "word_context": "arrived",
    "translat": "людина",
    "translat_context": "прибула",
    "dictionary": "людина",
    "lesson": "8"
  },
  {
    "word": "money",
    "word_context": "was stolen",
    "translat": "гроші",
    "translat_context": "було вкрадено",
    "dictionary": "гроші",
    "lesson": "8"
  },
  {
    "word": "serve",
    "word_context": "tea",
    "translat": "подавати",
    "translat_context": "чай",
    "dictionary": "подавати",
    "lesson": "8"
  },
  {
    "word": "appear",
    "word_context": "suddenly",
    "translat": "з’явитися",
    "translat_context": "раптово",
    "dictionary": "з’явитися",
    "lesson": "8"
  },
  {
    "word": "road",
    "word_context": "closed",
    "translat": "дорога",
    "translat_context": "закрита",
    "dictionary": "дорога",
    "lesson": "8"
  },
  {
    "word": "map",
    "word_context": "is old",
    "translat": "карта",
    "translat_context": "стара",
    "dictionary": "карта",
    "lesson": "8"
  },
  {
    "word": "rain",
    "word_context": "is heavy",
    "translat": "дощ",
    "translat_context": "сильний",
    "dictionary": "дощ",
    "lesson": "8"
  },
  {
    "word": "rule",
    "word_context": "applies",
    "translat": "правило",
    "translat_context": "застосовується",
    "dictionary": "правило",
    "lesson": "8"
  },
  {
    "word": "govern",
    "word_context": "wisely",
    "translat": "керувати",
    "translat_context": "мудро",
    "dictionary": "керувати",
    "lesson": "8"
  },
  {
    "word": "pull",
    "word_context": "hard",
    "translat": "тягни",
    "translat_context": "сильно",
    "dictionary": "тягнути",
    "lesson": "8"
  },
  {
    "word": "cold",
    "word_context": "night",
    "translat": "холодна",
    "translat_context": "ніч",
    "dictionary": "холодний",
    "lesson": "8"
  },
  {
    "word": "notice",
    "word_context": "the sign",
    "translat": "помітити",
    "translat_context": "знак",
    "dictionary": "помітити",
    "lesson": "8"
  },
  {
    "word": "voice",
    "word_context": "was loud",
    "translat": "голос",
    "translat_context": "був гучний",
    "dictionary": "голос",
    "lesson": "8"
  },
  {
    "word": "unit",
    "word_context": "of work",
    "translat": "одиниця",
    "translat_context": "роботи",
    "dictionary": "одиниця",
    "lesson": "8"
  },
  {
    "word": "power",
    "word_context": "and authority",
    "translat": "сила",
    "translat_context": "і влада",
    "dictionary": "сила",
    "lesson": "8"
  },
  {
    "word": "town",
    "word_context": "square",
    "translat": "міська",
    "translat_context": "площа",
    "dictionary": "місто",
    "lesson": "8"
  },
  {
    "word": "fine",
    "word_context": "details",
    "translat": "дрібні",
    "translat_context": "деталі",
    "dictionary": "дрібний",
    "lesson": "8"
  },
  {
    "word": "certain",
    "word_context": "truth",
    "translat": "певна",
    "translat_context": "правда",
    "dictionary": "певний",
    "lesson": "8"
  },
  {
    "word": "fly",
    "word_context": "fast",
    "translat": "летіти",
    "translat_context": "швидко",
    "dictionary": "летіти",
    "lesson": "8"
  },
  {
    "word": "fall",
    "word_context": "season",
    "translat": "осінь",
    "translat_context": "пора року",
    "dictionary": "осінь",
    "lesson": "8"
  },
  {
    "word": "lead",
    "word_context": "the team",
    "translat": "керувати",
    "translat_context": "командою",
    "dictionary": "керувати",
    "lesson": "8"
  },
  {
    "word": "cry",
    "word_context": "loudly",
    "translat": "плакати",
    "translat_context": "голосно",
    "dictionary": "плакати",
    "lesson": "8"
  },
  {
    "word": "dark",
    "word_context": "room",
    "translat": "темна",
    "translat_context": "кімната",
    "dictionary": "темний",
    "lesson": "8"
  },
  {
    "word": "machine",
    "word_context": "works",
    "translat": "машина",
    "translat_context": "працює",
    "dictionary": "машина",
    "lesson": "8"
  },
  {
    "word": "note",
    "word_context": "taken",
    "translat": "нотатка",
    "translat_context": "зроблена",
    "dictionary": "нотатка",
    "lesson": "8"
  },
  {
    "word": "wait",
    "word_context": "a minute",
    "translat": "зачекай",
    "translat_context": "хвилину",
    "dictionary": "чекати",
    "lesson": "8"
  },
  {
    "word": "plan",
    "word_context": "is ready",
    "translat": "план",
    "translat_context": "готовий",
    "dictionary": "план",
    "lesson": "8"
  },
  {
    "word": "figure",
    "word_context": "appears",
    "translat": "фігура",
    "translat_context": "з'являється",
    "dictionary": "фігура",
    "lesson": "8"
  },
  {
    "word": "star",
    "word_context": "shines",
    "translat": "зірка",
    "translat_context": "сяє",
    "dictionary": "зірка",
    "lesson": "9"
  },
  {
    "word": "box",
    "word_context": "is open",
    "translat": "коробка",
    "translat_context": "відкрита",
    "dictionary": "коробка",
    "lesson": "9"
  },
  {
    "word": "closed",
    "word_context": "for lunch",
    "translat": "закрито",
    "translat_context": "на обід",
    "dictionary": "закрито",
    "lesson": "9"
  },
  {
    "word": "field",
    "word_context": "work",
    "translat": "польова",
    "translat_context": "робота",
    "dictionary": "поле",
    "lesson": "9"
  },
  {
    "word": "rest",
    "word_context": "a while",
    "translat": "відпочинь",
    "translat_context": "трохи",
    "dictionary": "відпочивати",
    "lesson": "9"
  },
  {
    "word": "correct",
    "word_context": "answer",
    "translat": "правильна",
    "translat_context": "відповідь",
    "dictionary": "правильний",
    "lesson": "9"
  },
  {
    "word": "able",
    "word_context": "to help",
    "translat": "здатний",
    "translat_context": "допомогти",
    "dictionary": "здатний",
    "lesson": "9"
  },
  {
    "word": "computer",
    "word_context": "is broken",
    "translat": "комп'ютер",
    "translat_context": "зламаний",
    "dictionary": "комп'ютер",
    "lesson": "9"
  },
  {
    "word": "done",
    "word_context": "with care",
    "translat": "зроблено",
    "translat_context": "акуратно",
    "dictionary": "зроблено",
    "lesson": "9"
  },
  {
    "word": "beauty",
    "word_context": "of nature",
    "translat": "краса",
    "translat_context": "природи",
    "dictionary": "краса",
    "lesson": "9"
  },
  {
    "word": "drive",
    "word_context": "the car",
    "translat": "вести",
    "translat_context": "автомобіль",
    "dictionary": "вести",
    "lesson": "9"
  },
  {
    "word": "vegetable",
    "word_context": "soup",
    "translat": "овочевий",
    "translat_context": "суп",
    "dictionary": "овоч",
    "lesson": "9"
  },
  {
    "word": "contain",
    "word_context": "the liquid",
    "translat": "вміщувати",
    "translat_context": "рідину",
    "dictionary": "вміщувати",
    "lesson": "9"
  },
  {
    "word": "front",
    "word_context": "door",
    "translat": "передні",
    "translat_context": "двері",
    "dictionary": "передній",
    "lesson": "9"
  },
  {
    "word": "teach",
    "word_context": "students",
    "translat": "вчити",
    "translat_context": "учнів",
    "dictionary": "вчити",
    "lesson": "9"
  },
  {
    "word": "week",
    "word_context": "passed",
    "translat": "тиждень",
    "translat_context": "минув",
    "dictionary": "тиждень",
    "lesson": "9"
  },
  {
    "word": "final",
    "word_context": "round",
    "translat": "фінальний",
    "translat_context": "раунд",
    "dictionary": "фінальний",
    "lesson": "9"
  },
  {
    "word": "plate",
    "word_context": "of borsch",
    "translat": "тарілка",
    "translat_context": "борщу",
    "dictionary": "тарілка",
    "lesson": "9"
  },
  {
    "word": "green",
    "word_context": "leaves",
    "translat": "зелене",
    "translat_context": "листя",
    "dictionary": "зелений",
    "lesson": "9"
  },
  {
    "word": "quick",
    "word_context": "answer",
    "translat": "швидка",
    "translat_context": "відповідь",
    "dictionary": "швидкий",
    "lesson": "9"
  },
  {
    "word": "develop",
    "word_context": "new skills",
    "translat": "розвивати",
    "translat_context": "нові навички",
    "dictionary": "розвивати",
    "lesson": "9"
  },
  {
    "word": "ocean",
    "word_context": "waves",
    "translat": "океана",
    "translat_context": "хвилі",
    "dictionary": "океан",
    "lesson": "9"
  },
  {
    "word": "free",
    "word_context": "to go",
    "translat": "вільний",
    "translat_context": "іти",
    "dictionary": "вільний",
    "lesson": "9"
  },
  {
    "word": "minute",
    "word_context": "to spare",
    "translat": "хвилина",
    "translat_context": "в запасі",
    "dictionary": "хвилина",
    "lesson": "9"
  },
  {
    "word": "strong",
    "word_context": "wind",
    "translat": "сильний",
    "translat_context": "вітер",
    "dictionary": "сильний",
    "lesson": "9"
  },
  {
    "word": "special",
    "word_context": "occasion",
    "translat": "особлива",
    "translat_context": "подія",
    "dictionary": "особливий",
    "lesson": "9"
  },
  {
    "word": "mind",
    "word_context": "power",
    "translat": "розуму",
    "translat_context": "сила",
    "dictionary": "розум",
    "lesson": "9"
  },
  {
    "word": "clear",
    "word_context": "sky",
    "translat": "ясне",
    "translat_context": "небо",
    "dictionary": "ясний",
    "lesson": "9"
  },
  {
    "word": "tail",
    "word_context": "of the cat",
    "translat": "хвіст",
    "translat_context": "кота",
    "dictionary": "хвіст",
    "lesson": "9"
  },
  {
    "word": "produce",
    "word_context": "goods",
    "translat": "виробляти",
    "translat_context": "товари",
    "dictionary": "виробляти",
    "lesson": "9"
  },
  {
    "word": "fact",
    "word_context": "checked",
    "translat": "факт",
    "translat_context": "перевірено",
    "dictionary": "факт",
    "lesson": "9"
  },
  {
    "word": "street",
    "word_context": "lights",
    "translat": "вуличні",
    "translat_context": "ліхтарі",
    "dictionary": "вулиця",
    "lesson": "9"
  },
  {
    "word": "inch",
    "word_context": "closer",
    "translat": "дюйм",
    "translat_context": "ближче",
    "dictionary": "дюйм",
    "lesson": "9"
  },
  {
    "word": "multiply",
    "word_context": "numbers",
    "translat": "множити",
    "translat_context": "числа",
    "dictionary": "множити",
    "lesson": "9"
  },
  {
    "word": "nothing",
    "word_context": "to lose",
    "translat": "нічого",
    "translat_context": "втрачати",
    "dictionary": "нічого",
    "lesson": "9"
  },
  {
    "word": "course",
    "word_context": "of action",
    "translat": "курс",
    "translat_context": "дій",
    "dictionary": "курс",
    "lesson": "10"
  },
  {
    "word": "stay",
    "word_context": "home",
    "translat": "залишатися",
    "translat_context": "вдома",
    "dictionary": "залишатися",
    "lesson": "10"
  },
  {
    "word": "wheel",
    "word_context": "turns",
    "translat": "колесо",
    "translat_context": "обертається",
    "dictionary": "колесо",
    "lesson": "10"
  },
  {
    "word": "full",
    "word_context": "house",
    "translat": "повний",
    "translat_context": "дім",
    "dictionary": "повний",
    "lesson": "10"
  },
  {
    "word": "force",
    "word_context": "of nature",
    "translat": "сила",
    "translat_context": "природи",
    "dictionary": "сила",
    "lesson": "10"
  },
  {
    "word": "blue",
    "word_context": "sky",
    "translat": "синє",
    "translat_context": "небо",
    "dictionary": "синє",
    "lesson": "10"
  },
  {
    "word": "object",
    "word_context": "in motion",
    "translat": "об’єкт",
    "translat_context": "в русі",
    "dictionary": "об’єкт",
    "lesson": "10"
  },
  {
    "word": "decide",
    "word_context": "now",
    "translat": "вирішити",
    "translat_context": "зараз",
    "dictionary": "вирішити",
    "lesson": "10"
  },
  {
    "word": "surface",
    "word_context": "level",
    "translat": "поверхні",
    "translat_context": "рівень",
    "dictionary": "поверхня",
    "lesson": "10"
  },
  {
    "word": "deep",
    "word_context": "thought",
    "translat": "глибока",
    "translat_context": "думка",
    "dictionary": "глибока",
    "lesson": "10"
  },
  {
    "word": "moon",
    "word_context": "light",
    "translat": "місяць",
    "translat_context": "світить",
    "dictionary": "місяць",
    "lesson": "10"
  },
  {
    "word": "island",
    "word_context": "paradise",
    "translat": "острів",
    "translat_context": "райський",
    "dictionary": "острів",
    "lesson": "10"
  },
  {
    "word": "foot",
    "word_context": "step",
    "translat": "ноги",
    "translat_context": "крок",
    "dictionary": "нога",
    "lesson": "10"
  },
  {
    "word": "system",
    "word_context": "update",
    "translat": "системи",
    "translat_context": "оновлення",
    "dictionary": "система",
    "lesson": "10"
  },
  {
    "word": "test",
    "word_context": "result",
    "translat": "теста",
    "translat_context": "результат",
    "dictionary": "тест",
    "lesson": "10"
  },
  {
    "word": "record",
    "word_context": "breaking",
    "translat": "рекорд",
    "translat_context": "побито",
    "dictionary": "рекорд",
    "lesson": "10"
  },
  {
    "word": "boat",
    "word_context": "ride",
    "translat": "на човні",
    "translat_context": "прогулянка",
    "dictionary": "човен",
    "lesson": "10"
  },
  {
    "word": "common",
    "word_context": "sense",
    "translat": "здоровий",
    "translat_context": "глузд",
    "dictionary": "здоровий",
    "lesson": "10"
  },
  {
    "word": "gold",
    "word_context": "ring",
    "translat": "золоте",
    "translat_context": "кільце",
    "dictionary": "золоте",
    "lesson": "10"
  },
  {
    "word": "possible",
    "word_context": "outcome",
    "translat": "можливий",
    "translat_context": "результат",
    "dictionary": "можливий",
    "lesson": "10"
  },
  {
    "word": "plane",
    "word_context": "landing",
    "translat": "літак",
    "translat_context": "приземляється",
    "dictionary": "літак",
    "lesson": "10"
  },
  {
    "word": "instead",
    "word_context": "of war",
    "translat": "замість",
    "translat_context": "війни",
    "dictionary": "замість",
    "lesson": "10"
  },
  {
    "word": "dry",
    "word_context": "clothes",
    "translat": "сухий",
    "translat_context": "одяг",
    "dictionary": "сухий",
    "lesson": "10"
  },
  {
    "word": "wonder",
    "word_context": "why",
    "translat": "дивуватись",
    "translat_context": "чому",
    "dictionary": "дивуватись",
    "lesson": "10"
  },
  {
    "word": "ago",
    "word_context": "years",
    "translat": "тому назад",
    "translat_context": "років",
    "dictionary": "тому назад",
    "lesson": "10"
  },
  {
    "word": "run",
    "word_context": "fast",
    "translat": "бігати",
    "translat_context": "швидко",
    "dictionary": "бігати",
    "lesson": "10"
  },
  {
    "word": "check",
    "word_context": "the list",
    "translat": "перевірити",
    "translat_context": "список",
    "dictionary": "перевірити",
    "lesson": "10"
  },
  {
    "word": "game",
    "word_context": "night",
    "translat": "гра",
    "translat_context": "ввечері",
    "dictionary": "гра",
    "lesson": "10"
  },
  {
    "word": "shape",
    "word_context": "of heart",
    "translat": "форма",
    "translat_context": "серця",
    "dictionary": "форма",
    "lesson": "10"
  },
  {
    "word": "translate",
    "word_context": "to English",
    "translat": "перекладати",
    "translat_context": "на англійську",
    "dictionary": "перекладати",
    "lesson": "10"
  },
  {
    "word": "hot",
    "word_context": "day",
    "translat": "спекотний",
    "translat_context": "день",
    "dictionary": "спекотний",
    "lesson": "10"
  },
  {
    "word": "miss",
    "word_context": "the bus",
    "translat": "пропустити",
    "translat_context": "автобус",
    "dictionary": "пропустити",
    "lesson": "10"
  },
  {
    "word": "daughter",
    "word_context": "and son",
    "translat": "донька",
    "translat_context": "і син",
    "dictionary": "донька",
    "lesson": "10"
  },
  {
    "word": "heat",
    "word_context": "wave",
    "translat": "спеки",
    "translat_context": "хвиля",
    "dictionary": "спека",
    "lesson": "10"
  },
  {
    "word": "snow",
    "word_context": "is falling",
    "translat": "сніг",
    "translat_context": "падає",
    "dictionary": "сніг",
    "lesson": "10"
  },
  {
    "word": "tire",
    "word_context": "pressure",
    "translat": "шини",
    "translat_context": "тиск",
    "dictionary": "шина",
    "lesson": "11"
  },
  {
    "word": "bring",
    "word_context": "a coat",
    "translat": "принеси",
    "translat_context": "пальто",
    "dictionary": "принеси",
    "lesson": "11"
  },
  {
    "word": "yes",
    "word_context": "please",
    "translat": "так",
    "translat_context": "будь ласка",
    "dictionary": "так",
    "lesson": "11"
  },
  {
    "word": "distant",
    "word_context": "land",
    "translat": "далека",
    "translat_context": "земля",
    "dictionary": "далекий",
    "lesson": "11"
  },
  {
    "word": "fill",
    "word_context": "the form",
    "translat": "заповнити",
    "translat_context": "форму",
    "dictionary": "заповнити",
    "lesson": "11"
  },
  {
    "word": "east",
    "word_context": "side",
    "translat": "східна",
    "translat_context": "сторона",
    "dictionary": "схід",
    "lesson": "11"
  },
  {
    "word": "paint",
    "word_context": "the wall",
    "translat": "фарбувати",
    "translat_context": "стіну",
    "dictionary": "фарбувати",
    "lesson": "11"
  },
  {
    "word": "language",
    "word_context": "barrier",
    "translat": "мова",
    "translat_context": "бар'єр",
    "dictionary": "мова",
    "lesson": "11"
  },
  {
    "word": "grand",
    "word_context": "finale",
    "translat": "грандіозний",
    "translat_context": "фінал",
    "dictionary": "грандіозний",
    "lesson": "11"
  },
  {
    "word": "ball",
    "word_context": "is white",
    "translat": "м'яч",
    "translat_context": "білий",
    "dictionary": "м'яч",
    "lesson": "11"
  },
  {
    "word": "wave",
    "word_context": "hello",
    "translat": "помахати",
    "translat_context": "привітно",
    "dictionary": "помахати",
    "lesson": "11"
  },
  {
    "word": "drop",
    "word_context": "of water",
    "translat": "крапля",
    "translat_context": "води",
    "dictionary": "крапля",
    "lesson": "11"
  },
  {
    "word": "heart",
    "word_context": "beats",
    "translat": "серце",
    "translat_context": "б’ється",
    "dictionary": "серце",
    "lesson": "11"
  },
  {
    "word": "heavy",
    "word_context": "bag",
    "translat": "важка",
    "translat_context": "сумка",
    "dictionary": "важкий",
    "lesson": "11"
  },
  {
    "word": "dance",
    "word_context": "floor",
    "translat": "танцювальний",
    "translat_context": "майданчик",
    "dictionary": "танцювальний",
    "lesson": "11"
  },
  {
    "word": "engine",
    "word_context": "start",
    "translat": "двигун",
    "translat_context": "стартує",
    "dictionary": "двигун",
    "lesson": "11"
  },
  {
    "word": "position",
    "word_context": "open",
    "translat": "позиція",
    "translat_context": "відкрита",
    "dictionary": "позиція",
    "lesson": "11"
  },
  {
    "word": "arm",
    "word_context": "muscle",
    "translat": "руки",
    "translat_context": "м'яз",
    "dictionary": "рука",
    "lesson": "11"
  },
  {
    "word": "wide",
    "word_context": "open",
    "translat": "широко",
    "translat_context": "відкрито",
    "dictionary": "широкий",
    "lesson": "11"
  },
  {
    "word": "sail",
    "word_context": "away",
    "translat": "відплисти",
    "translat_context": "геть",
    "dictionary": "плавати",
    "lesson": "11"
  },
  {
    "word": "material",
    "word_context": "goods",
    "translat": "матеріальні",
    "translat_context": "товари",
    "dictionary": "матеріальний",
    "lesson": "11"
  },
  {
    "word": "size",
    "word_context": "matters",
    "translat": "розмір",
    "translat_context": "важливий",
    "dictionary": "розмір",
    "lesson": "11"
  },
  {
    "word": "vary",
    "word_context": "greatly",
    "translat": "відрізнятися",
    "translat_context": "значно",
    "dictionary": "відрізнятися",
    "lesson": "11"
  },
  {
    "word": "settle",
    "word_context": "down",
    "translat": "оселитися",
    "translat_context": "спокійно",
    "dictionary": "оселитися",
    "lesson": "11"
  },
  {
    "word": "speak",
    "word_context": "clearly",
    "translat": "говорити",
    "translat_context": "чітко",
    "dictionary": "говорити",
    "lesson": "11"
  },
  {
    "word": "weight",
    "word_context": "gain",
    "translat": "ваги",
    "translat_context": "набір",
    "dictionary": "ваги",
    "lesson": "11"
  },
  {
    "word": "general",
    "word_context": "idea",
    "translat": "загальна",
    "translat_context": "ідея",
    "dictionary": "загальний",
    "lesson": "11"
  },
  {
    "word": "ice",
    "word_context": "is thin",
    "translat": "лід",
    "translat_context": "тонкий",
    "dictionary": "лід",
    "lesson": "11"
  },
  {
    "word": "matter",
    "word_context": "of time",
    "translat": "питання",
    "translat_context": "часу",
    "dictionary": "питання",
    "lesson": "11"
  },
  {
    "word": "circle",
    "word_context": "of friends",
    "translat": "коло",
    "translat_context": "друзів",
    "dictionary": "коло",
    "lesson": "11"
  },
  {
    "word": "pair",
    "word_context": "of shoes",
    "translat": "пара",
    "translat_context": "взуття",
    "dictionary": "пара",
    "lesson": "11"
  },
  {
    "word": "include",
    "word_context": "details",
    "translat": "включати",
    "translat_context": "деталі",
    "dictionary": "включати",
    "lesson": "11"
  },
  {
    "word": "divide",
    "word_context": "the cake",
    "translat": "розділити",
    "translat_context": "торт",
    "dictionary": "розділити",
    "lesson": "11"
  },
  {
    "word": "different",
    "word_context": "opinion",
    "translat": "інша",
    "translat_context": "думка",
    "dictionary": "інший",
    "lesson": "11"
  },
  {
    "word": "felt",
    "word_context": "cold",
    "translat": "відчував",
    "translat_context": "холод",
    "dictionary": "відчував",
    "lesson": "11"
  },
  {
    "word": "perhaps",
    "word_context": "later",
    "translat": "можливо",
    "translat_context": "пізніше",
    "dictionary": "можливо",
    "lesson": "12"
  },
  {
    "word": "pick",
    "word_context": "a flower",
    "translat": "зірвати",
    "translat_context": "квітку",
    "dictionary": "зривати",
    "lesson": "12"
  },
  {
    "word": "count",
    "word_context": "the stars",
    "translat": "рахувати",
    "translat_context": "зірки",
    "dictionary": "рахувати",
    "lesson": "12"
  },
  {
    "word": "square",
    "word_context": "shape",
    "translat": "квадратна",
    "translat_context": "форма",
    "dictionary": "квадрат",
    "lesson": "12"
  },
  {
    "word": "reason",
    "word_context": "why",
    "translat": "причина",
    "translat_context": "чому",
    "dictionary": "причина",
    "lesson": "12"
  },
  {
    "word": "length",
    "word_context": "of rope",
    "translat": "довжина",
    "translat_context": "мотузки",
    "dictionary": "довжина",
    "lesson": "12"
  },
  {
    "word": "represent",
    "word_context": "the group",
    "translat": "представляти",
    "translat_context": "групу",
    "dictionary": "представляти",
    "lesson": "12"
  },
  {
    "word": "art",
    "word_context": "is eternal",
    "translat": "мистецтво",
    "translat_context": "вічне",
    "dictionary": "мистецтво",
    "lesson": "12"
  },
  {
    "word": "subject",
    "word_context": "of interest",
    "translat": "предмет",
    "translat_context": "інтересу",
    "dictionary": "предмет",
    "lesson": "12"
  },
  {
    "word": "region",
    "word_context": "center",
    "translat": "регіональний",
    "translat_context": "центр",
    "dictionary": "регіон",
    "lesson": "12"
  },
  {
    "word": "energy",
    "word_context": "source",
    "translat": "енергії",
    "translat_context": "джерело",
    "dictionary": "енергія",
    "lesson": "12"
  },
  {
    "word": "hunt",
    "word_context": "for food",
    "translat": "полювання",
    "translat_context": "на їжу",
    "dictionary": "полювання",
    "lesson": "12"
  },
  {
    "word": "probable",
    "word_context": "cause",
    "translat": "ймовірна",
    "translat_context": "причина",
    "dictionary": "ймовірна",
    "lesson": "12"
  },
  {
    "word": "bed",
    "word_context": "is soft",
    "translat": "ліжко",
    "translat_context": "м’яке",
    "dictionary": "ліжко",
    "lesson": "12"
  },
  {
    "word": "brother",
    "word_context": "and sister",
    "translat": "брат",
    "translat_context": "і сестра",
    "dictionary": "брат",
    "lesson": "12"
  },
  {
    "word": "egg",
    "word_context": "is boiled",
    "translat": "яйце",
    "translat_context": "зварене",
    "dictionary": "яйце",
    "lesson": "12"
  },
  {
    "word": "ride",
    "word_context": "a bike",
    "translat": "їхати",
    "translat_context": "на велосипеді",
    "dictionary": "їхати верхом",
    "lesson": "12"
  },
  {
    "word": "cell",
    "word_context": "division",
    "translat": "клітини",
    "translat_context": "ділення",
    "dictionary": "клітина",
    "lesson": "12"
  },
  {
    "word": "believe",
    "word_context": "in yourself",
    "translat": "вірити",
    "translat_context": "в себе",
    "dictionary": "вірити",
    "lesson": "12"
  },
  {
    "word": "forget",
    "word_context": "it",
    "translat": "забудь",
    "translat_context": "про це",
    "dictionary": "забувати",
    "lesson": "12"
  },
  {
    "word": "forest",
    "word_context": "path",
    "translat": "лісовий",
    "translat_context": "шлях",
    "dictionary": "лісовий",
    "lesson": "12"
  },
  {
    "word": "sit",
    "word_context": "down",
    "translat": "сісти",
    "translat_context": "долу",
    "dictionary": "сісти",
    "lesson": "12"
  },
  {
    "word": "race",
    "word_context": "began",
    "translat": "гонка",
    "translat_context": "почалась",
    "dictionary": "гонка",
    "lesson": "12"
  },
  {
    "word": "window",
    "word_context": "is open",
    "translat": "вікно",
    "translat_context": "відкрите",
    "dictionary": "вікно",
    "lesson": "12"
  },
  {
    "word": "store",
    "word_context": "assistant",
    "translat": "магазина",
    "translat_context": "продавець",
    "dictionary": "магазин",
    "lesson": "12"
  },
  {
    "word": "summer",
    "word_context": "vacation",
    "translat": "літня",
    "translat_context": "відпустка",
    "dictionary": "літо",
    "lesson": "12"
  },
  {
    "word": "train",
    "word_context": "arrived",
    "translat": "поїзд",
    "translat_context": "прибув",
    "dictionary": "поїзд",
    "lesson": "12"
  },
  {
    "word": "sleep",
    "word_context": "tight",
    "translat": "спати",
    "translat_context": "міцно",
    "dictionary": "спати",
    "lesson": "12"
  },
  {
    "word": "prove",
    "word_context": "your point",
    "translat": "довести",
    "translat_context": "точку зору",
    "dictionary": "довести",
    "lesson": "12"
  },
  {
    "word": "lone",
    "word_context": "wolf",
    "translat": "самотній",
    "translat_context": "вовк",
    "dictionary": "самотній",
    "lesson": "12"
  },
  {
    "word": "leg",
    "word_context": "pain",
    "translat": "ноги",
    "translat_context": "біль",
    "dictionary": "нога",
    "lesson": "12"
  },
  {
    "word": "exercise",
    "word_context": "daily",
    "translat": "вправи",
    "translat_context": "щоденні",
    "dictionary": "вправи",
    "lesson": "12"
  },
  {
    "word": "wall",
    "word_context": "is high",
    "translat": "стіна",
    "translat_context": "висока",
    "dictionary": "стіна",
    "lesson": "12"
  },
  {
    "word": "catch",
    "word_context": "the ball",
    "translat": "спіймай",
    "translat_context": "м’яч",
    "dictionary": "спіймай",
    "lesson": "12"
  },
  {
    "word": "mount",
    "word_context": "camera",
    "translat": "прикріпити",
    "translat_context": "камеру",
    "dictionary": "прикріпити",
    "lesson": "12"
  },
  {
    "word": "wish",
    "word_context": "granted",
    "translat": "бажання",
    "translat_context": "виконано",
    "dictionary": "бажання",
    "lesson": "13"
  },
  {
    "word": "sky",
    "word_context": "is blue",
    "translat": "небо",
    "translat_context": "синє",
    "dictionary": "небо",
    "lesson": "13"
  },
  {
    "word": "board",
    "word_context": "wall",
    "translat": "дошкова",
    "translat_context": "стіна",
    "dictionary": "дошка",
    "lesson": "13"
  },
  {
    "word": "joy",
    "word_context": "and laughter",
    "translat": "радість",
    "translat_context": "і сміх",
    "dictionary": "радість",
    "lesson": "13"
  },
  {
    "word": "winter",
    "word_context": "coat",
    "translat": "зимове",
    "translat_context": "пальто",
    "dictionary": "зима",
    "lesson": "13"
  },
  {
    "word": "finally",
    "word_context": "it happened",
    "translat": "нарешті",
    "translat_context": "це сталося",
    "dictionary": "нарешті",
    "lesson": "13"
  },
  {
    "word": "written",
    "word_context": "by hand",
    "translat": "написано",
    "translat_context": "від руки",
    "dictionary": "написано",
    "lesson": "13"
  },
  {
    "word": "wild",
    "word_context": "animal",
    "translat": "дика",
    "translat_context": "тварина",
    "dictionary": "дикий",
    "lesson": "13"
  },
  {
    "word": "instrument",
    "word_context": "plays well",
    "translat": "інструмент",
    "translat_context": "добре звучить",
    "dictionary": "інструмент",
    "lesson": "13"
  },
  {
    "word": "kept",
    "word_context": "secret",
    "translat": "збережена",
    "translat_context": "таємницю",
    "dictionary": "збережений",
    "lesson": "13"
  },
  {
    "word": "glass",
    "word_context": "of water",
    "translat": "склянка",
    "translat_context": "води",
    "dictionary": "склянка",
    "lesson": "13"
  },
  {
    "word": "grass",
    "word_context": "is green",
    "translat": "трава",
    "translat_context": "зелена",
    "dictionary": "трава",
    "lesson": "13"
  },
  {
    "word": "cow",
    "word_context": "in field",
    "translat": "корова",
    "translat_context": "на полі",
    "dictionary": "корова",
    "lesson": "13"
  },
  {
    "word": "job",
    "word_context": "offer",
    "translat": "роботи",
    "translat_context": "пропозиція",
    "dictionary": "робота",
    "lesson": "13"
  },
  {
    "word": "edge",
    "word_context": "of cliff",
    "translat": "край",
    "translat_context": "обриву",
    "dictionary": "край",
    "lesson": "13"
  },
  {
    "word": "sign",
    "word_context": "of peace",
    "translat": "знак",
    "translat_context": "миру",
    "dictionary": "знак",
    "lesson": "13"
  },
  {
    "word": "visit",
    "word_context": "the doctor",
    "translat": "відвідати",
    "translat_context": "лікаря",
    "dictionary": "відвідати",
    "lesson": "13"
  },
  {
    "word": "past",
    "word_context": "events",
    "translat": "минулі",
    "translat_context": "події",
    "dictionary": "минулий",
    "lesson": "13"
  },
  {
    "word": "soft",
    "word_context": "pillow",
    "translat": "м’яка",
    "translat_context": "подушка",
    "dictionary": "м’який",
    "lesson": "13"
  },
  {
    "word": "fun",
    "word_context": "activity",
    "translat": "весела",
    "translat_context": "активність",
    "dictionary": "веселощі",
    "lesson": "13"
  },
  {
    "word": "gas",
    "word_context": "pipe",
    "translat": "газова",
    "translat_context": "труба",
    "dictionary": "газ",
    "lesson": "13"
  },
  {
    "word": "weather",
    "word_context": "forecast",
    "translat": "погоди",
    "translat_context": "прогноз",
    "dictionary": "погода",
    "lesson": "13"
  },
  {
    "word": "month",
    "word_context": "of July",
    "translat": "місяць",
    "translat_context": "липень",
    "dictionary": "місяць",
    "lesson": "13"
  },
  {
    "word": "bear",
    "word_context": "is sleeping",
    "translat": "ведмідь",
    "translat_context": "спить",
    "dictionary": "ведмідь",
    "lesson": "13"
  },
  {
    "word": "finish",
    "word_context": "line",
    "translat": "фінішна",
    "translat_context": "лінія",
    "dictionary": "фініш",
    "lesson": "13"
  },
  {
    "word": "happy",
    "word_context": "ending",
    "translat": "щасливий",
    "translat_context": "кінець",
    "dictionary": "щасливий",
    "lesson": "13"
  },
  {
    "word": "hope",
    "word_context": "remains",
    "translat": "надія",
    "translat_context": "залишається",
    "dictionary": "надія",
    "lesson": "13"
  },
  {
    "word": "flower",
    "word_context": "blooms",
    "translat": "квітка",
    "translat_context": "цвіте",
    "dictionary": "квітка",
    "lesson": "13"
  },
  {
    "word": "clothes",
    "word_context": "shop",
    "translat": "одягу",
    "translat_context": "магазин",
    "dictionary": "одяг",
    "lesson": "13"
  },
  {
    "word": "strange",
    "word_context": "noise",
    "translat": "дивний",
    "translat_context": "звук",
    "dictionary": "дивний",
    "lesson": "13"
  },
  {
    "word": "gone",
    "word_context": "wrong",
    "translat": "пішло",
    "translat_context": "не так",
    "dictionary": "пішло",
    "lesson": "13"
  },
  {
    "word": "jump",
    "word_context": "high",
    "translat": "стрибай",
    "translat_context": "високо",
    "dictionary": "стрибати",
    "lesson": "13"
  },
  {
    "word": "baby",
    "word_context": "is crying",
    "translat": "немовля",
    "translat_context": "плаче",
    "dictionary": "немовля",
    "lesson": "13"
  },
  {
    "word": "village",
    "word_context": "life",
    "translat": "сільське",
    "translat_context": "життя",
    "dictionary": "село",
    "lesson": "13"
  },
  {
    "word": "meet",
    "word_context": "friends",
    "translat": "зустріти",
    "translat_context": "друзів",
    "dictionary": "зустріти",
    "lesson": "13"
  },
  {
    "word": "root",
    "word_context": "system",
    "translat": "коренева",
    "translat_context": "система",
    "dictionary": "корінь",
    "lesson": "14"
  },
  {
    "word": "buy",
    "word_context": "groceries",
    "translat": "купити",
    "translat_context": "продукти",
    "dictionary": "купити",
    "lesson": "14"
  },
  {
    "word": "raise",
    "word_context": "a hand",
    "translat": "підняти",
    "translat_context": "руку",
    "dictionary": "підняти",
    "lesson": "14"
  },
  {
    "word": "solve",
    "word_context": "the puzzle",
    "translat": "вирішити",
    "translat_context": "головоломку",
    "dictionary": "вирішити",
    "lesson": "14"
  },
  {
    "word": "metal",
    "word_context": "box",
    "translat": "металева",
    "translat_context": "коробка",
    "dictionary": "метал",
    "lesson": "14"
  },
  {
    "word": "whether",
    "word_context": "you want",
    "translat": "чи",
    "translat_context": "ти хочеш",
    "dictionary": "чи",
    "lesson": "14"
  },
  {
    "word": "push",
    "word_context": "the button",
    "translat": "натиснути",
    "translat_context": "кнопку",
    "dictionary": "натиснути",
    "lesson": "14"
  },
  {
    "word": "paragraph",
    "word_context": "is long",
    "translat": "абзац",
    "translat_context": "довгий",
    "dictionary": "абзац",
    "lesson": "14"
  },
  {
    "word": "everything",
    "word_context": "possible",
    "translat": "все",
    "translat_context": "можливе",
    "dictionary": "все",
    "lesson": "14"
  },
  {
    "word": "hair",
    "word_context": "is short",
    "translat": "волосся",
    "translat_context": "коротке",
    "dictionary": "волосся",
    "lesson": "14"
  },
  {
    "word": "describe",
    "word_context": "the object",
    "translat": "опиши",
    "translat_context": "предмет",
    "dictionary": "опиши",
    "lesson": "14"
  },
  {
    "word": "cook",
    "word_context": "dinner",
    "translat": "готувати",
    "translat_context": "вечерю",
    "dictionary": "готувати",
    "lesson": "14"
  },
  {
    "word": "floor",
    "word_context": "is clean",
    "translat": "підлога",
    "translat_context": "чиста",
    "dictionary": "підлога",
    "lesson": "14"
  },
  {
    "word": "result",
    "word_context": "was great",
    "translat": "результат",
    "translat_context": "чудовий",
    "dictionary": "результат",
    "lesson": "14"
  },
  {
    "word": "burn",
    "word_context": "wood",
    "translat": "спалити",
    "translat_context": "деревину",
    "dictionary": "спалити",
    "lesson": "14"
  },
  {
    "word": "hill",
    "word_context": "top",
    "translat": "пагорба",
    "translat_context": "верхівка",
    "dictionary": "пагорб",
    "lesson": "14"
  },
  {
    "word": "safe",
    "word_context": "place",
    "translat": "безпечне",
    "translat_context": "місце",
    "dictionary": "безпечний",
    "lesson": "14"
  },
  {
    "word": "cat",
    "word_context": "is sleeping",
    "translat": "кіт",
    "translat_context": "спить",
    "dictionary": "кіт",
    "lesson": "14"
  },
  {
    "word": "century",
    "word_context": "ago",
    "translat": "століття",
    "translat_context": "тому",
    "dictionary": "століття",
    "lesson": "14"
  },
  {
    "word": "consider",
    "word_context": "this idea",
    "translat": "розглянь",
    "translat_context": "цю ідею",
    "dictionary": "розглянь",
    "lesson": "14"
  },
  {
    "word": "type",
    "word_context": "your name",
    "translat": "введи",
    "translat_context": "своє ім’я",
    "dictionary": "введи",
    "lesson": "14"
  },
  {
    "word": "law",
    "word_context": "and order",
    "translat": "і порядок",
    "translat_context": "школа",
    "dictionary": "закон",
    "lesson": "14"
  },
  {
    "word": "bit",
    "word_context": "of sugar",
    "translat": "трохи",
    "translat_context": "цукру",
    "dictionary": "трохи",
    "lesson": "14"
  },
  {
    "word": "coast",
    "word_context": "view",
    "translat": "узбережжя",
    "translat_context": "вид",
    "dictionary": "узбережжя",
    "lesson": "14"
  },
  {
    "word": "copy",
    "word_context": "the file",
    "translat": "копіювати",
    "translat_context": "файл",
    "dictionary": "копіювати",
    "lesson": "14"
  },
  {
    "word": "phrase",
    "word_context": "meeaning",
    "translat": "фрази",
    "translat_context": "значення",
    "dictionary": "фраза",
    "lesson": "14"
  },
  {
    "word": "silent",
    "word_context": "mode",
    "translat": "тихий",
    "translat_context": "режим",
    "dictionary": "тихий",
    "lesson": "14"
  },
  {
    "word": "tall",
    "word_context": "building",
    "translat": "висока",
    "translat_context": "будівля",
    "dictionary": "високий",
    "lesson": "14"
  },
  {
    "word": "sand",
    "word_context": "castle",
    "translat": "пісочний",
    "translat_context": "замок",
    "dictionary": "пісочний",
    "lesson": "14"
  },
  {
    "word": "soil",
    "word_context": "is dry",
    "translat": "ґрунт",
    "translat_context": "сухий",
    "dictionary": "ґрунт",
    "lesson": "14"
  },
  {
    "word": "roll",
    "word_context": "back",
    "translat": "котити",
    "translat_context": "назад (скасувати)",
    "dictionary": "котити",
    "lesson": "14"
  },
  {
    "word": "temperature",
    "word_context": "is high",
    "translat": "температура",
    "translat_context": "висока",
    "dictionary": "температура",
    "lesson": "14"
  },
  {
    "word": "finger",
    "word_context": "point",
    "translat": "палець",
    "translat_context": "вказівний",
    "dictionary": "палець",
    "lesson": "14"
  },
  {
    "word": "industry",
    "word_context": "grows",
    "translat": "індустрія",
    "translat_context": "зростає",
    "dictionary": "індустрія",
    "lesson": "14"
  },
  {
    "word": "value",
    "word_context": "of time",
    "translat": "цінність",
    "translat_context": "часу",
    "dictionary": "цінність",
    "lesson": "14"
  },
  {
    "word": "fight",
    "word_context": "begins",
    "translat": "бійка",
    "translat_context": "починається",
    "dictionary": "бійка",
    "lesson": "15"
  },
  {
    "word": "lie",
    "word_context": "down",
    "translat": "лягти",
    "translat_context": "долу",
    "dictionary": "лягти",
    "lesson": "15"
  },
  {
    "word": "beat",
    "word_context": "the drum",
    "translat": "бити",
    "translat_context": "в барабан",
    "dictionary": "бити",
    "lesson": "15"
  },
  {
    "word": "excite",
    "word_context": "the crowd",
    "translat": "захопити",
    "translat_context": "натовп",
    "dictionary": "захопити",
    "lesson": "15"
  },
  {
    "word": "natural",
    "word_context": "light",
    "translat": "природне",
    "translat_context": "світло",
    "dictionary": "природній",
    "lesson": "15"
  },
  {
    "word": "view",
    "word_context": "from above",
    "translat": "вид",
    "translat_context": "згори",
    "dictionary": "вид",
    "lesson": "15"
  },
  {
    "word": "sense",
    "word_context": "of smell",
    "translat": "відчуття",
    "translat_context": "запаху",
    "dictionary": "відчуття",
    "lesson": "15"
  },
  {
    "word": "ear",
    "word_context": "pain",
    "translat": "вухо",
    "translat_context": "болить",
    "dictionary": "вухо",
    "lesson": "15"
  },
  {
    "word": "else",
    "word_context": "matters",
    "translat": "інше",
    "translat_context": "має значення",
    "dictionary": "інше",
    "lesson": "15"
  },
  {
    "word": "quite",
    "word_context": "certainly",
    "translat": "доволі",
    "translat_context": "впевнено",
    "dictionary": "доволі",
    "lesson": "15"
  },
  {
    "word": "actually",
    "word_context": "quite good",
    "translat": "насправді",
    "translat_context": "досить непогано",
    "dictionary": "насправді",
    "lesson": "15"
  },
  {
    "word": "case",
    "word_context": "is closed",
    "translat": "справа",
    "translat_context": "закрита",
    "dictionary": "справа",
    "lesson": "15"
  },
  {
    "word": "middle",
    "word_context": "of day",
    "translat": "середина",
    "translat_context": "дня",
    "dictionary": "середина",
    "lesson": "15"
  },
  {
    "word": "kill",
    "word_context": "the time",
    "translat": "вбивати",
    "translat_context": "час",
    "dictionary": "вбивати",
    "lesson": "15"
  },
  {
    "word": "son",
    "word_context": "and daughter",
    "translat": "син",
    "translat_context": "і донька",
    "dictionary": "син",
    "lesson": "15"
  },
  {
    "word": "lake",
    "word_context": "is big",
    "translat": "озеро",
    "translat_context": "велике",
    "dictionary": "озеро",
    "lesson": "15"
  },
  {
    "word": "moment",
    "word_context": "of truth",
    "translat": "момент",
    "translat_context": "істини",
    "dictionary": "момент",
    "lesson": "15"
  },
  {
    "word": "scales",
    "word_context": "show your weight",
    "translat": "ваги",
    "translat_context": "показують твою вагу",
    "dictionary": "ваги",
    "lesson": "15"
  },
  {
    "word": "loud",
    "word_context": "sound",
    "translat": "гучний",
    "translat_context": "звук",
    "dictionary": "гучний",
    "lesson": "15"
  },
  {
    "word": "spring",
    "word_context": "flowers",
    "translat": "весняні",
    "translat_context": "квіти",
    "dictionary": "весна",
    "lesson": "15"
  },
  {
    "word": "observe",
    "word_context": "the stars",
    "translat": "спостерігати",
    "translat_context": "за зірками",
    "dictionary": "спостерігати",
    "lesson": "15"
  },
  {
    "word": "child",
    "word_context": "is crying",
    "translat": "дитина",
    "translat_context": "плаче",
    "dictionary": "дитина",
    "lesson": "15"
  },
  {
    "word": "straight",
    "word_context": "line",
    "translat": "пряма",
    "translat_context": "лінія",
    "dictionary": "прямий",
    "lesson": "15"
  },
  {
    "word": "consonant",
    "word_context": "sound",
    "translat": "приголосний",
    "translat_context": "звук",
    "dictionary": "приголосний",
    "lesson": "15"
  },
  {
    "word": "nation",
    "word_context": "grows",
    "translat": "нація",
    "translat_context": "зростає",
    "dictionary": "нація",
    "lesson": "15"
  },
  {
    "word": "dictionary",
    "word_context": "definition",
    "translat": "словникове",
    "translat_context": "визначення",
    "dictionary": "словник",
    "lesson": "15"
  },
  {
    "word": "milk",
    "word_context": "bottle",
    "translat": "молока",
    "translat_context": "пляшка",
    "dictionary": "молоко",
    "lesson": "15"
  },
  {
    "word": "speed",
    "word_context": "limit",
    "translat": "швидкості",
    "translat_context": "обмеження",
    "dictionary": "швидкість",
    "lesson": "15"
  },
  {
    "word": "method",
    "word_context": "used",
    "translat": "метод",
    "translat_context": "застосовано",
    "dictionary": "метод",
    "lesson": "15"
  },
  {
    "word": "organ",
    "word_context": "donor",
    "translat": "органів",
    "translat_context": "донор",
    "dictionary": "орган",
    "lesson": "15"
  },
  {
    "word": "pay",
    "word_context": "the bill",
    "translat": "оплатити",
    "translat_context": "рахунок",
    "dictionary": "оплатити",
    "lesson": "15"
  },
  {
    "word": "age",
    "word_context": "group",
    "translat": "вікова",
    "translat_context": "група",
    "dictionary": "вік",
    "lesson": "15"
  },
  {
    "word": "section",
    "word_context": "of text",
    "translat": "розділ",
    "translat_context": "тексту",
    "dictionary": "розділ",
    "lesson": "15"
  },
  {
    "word": "dress",
    "word_context": "code",
    "translat": "дрес",
    "translat_context": "код",
    "dictionary": "одяг",
    "lesson": "15"
  },
  {
    "word": "cloud",
    "word_context": "storage",
    "translat": "хмарне",
    "translat_context": "сховище",
    "dictionary": "хмара",
    "lesson": "15"
  },
  {
    "word": "surprise",
    "word_context": "party",
    "translat": "сюрпризна",
    "translat_context": "вечірка",
    "dictionary": "сюрприз",
    "lesson": "16"
  },
  {
    "word": "quiet",
    "word_context": "room",
    "translat": "тиха",
    "translat_context": "кімната",
    "dictionary": "тихий",
    "lesson": "16"
  },
  {
    "word": "stone",
    "word_context": "wall",
    "translat": "кам’яна",
    "translat_context": "стіна",
    "dictionary": "камінь",
    "lesson": "16"
  },
  {
    "word": "tiny",
    "word_context": "insect",
    "translat": "крихітна",
    "translat_context": "комаха",
    "dictionary": "крихітний",
    "lesson": "16"
  },
  {
    "word": "climb",
    "word_context": "the hill",
    "translat": "піднятися",
    "translat_context": "на пагорб",
    "dictionary": "піднятися",
    "lesson": "16"
  },
  {
    "word": "cool",
    "word_context": "breeze",
    "translat": "прохолодний",
    "translat_context": "вітерець",
    "dictionary": "прохолодний",
    "lesson": "16"
  },
  {
    "word": "design",
    "word_context": "idea",
    "translat": "дизайн",
    "translat_context": "ідея",
    "dictionary": "дизайн",
    "lesson": "16"
  },
  {
    "word": "poor",
    "word_context": "people",
    "translat": "бідні",
    "translat_context": "люди",
    "dictionary": "бідний",
    "lesson": "16"
  },
  {
    "word": "a lot of",
    "word_context": "fun",
    "translat": "багато",
    "translat_context": "веселощів",
    "dictionary": "багато",
    "lesson": "16"
  },
  {
    "word": "experiment",
    "word_context": "results",
    "translat": "експерименту",
    "translat_context": "результати",
    "dictionary": "експеримент",
    "lesson": "16"
  },
  {
    "word": "bottom",
    "word_context": "shelf",
    "translat": "нижня",
    "translat_context": "полиця",
    "dictionary": "нижній",
    "lesson": "16"
  },
  {
    "word": "key",
    "word_context": "to door",
    "translat": "ключ",
    "translat_context": "до дверей",
    "dictionary": "ключ",
    "lesson": "16"
  },
  {
    "word": "iron",
    "word_context": "fence",
    "translat": "залізна",
    "translat_context": "огорожа",
    "dictionary": "залізо",
    "lesson": "16"
  },
  {
    "word": "single",
    "word_context": "word",
    "translat": "одне",
    "translat_context": "слово",
    "dictionary": "один",
    "lesson": "16"
  },
  {
    "word": "stick",
    "word_context": "to plan",
    "translat": "дотримуйся",
    "translat_context": "плану",
    "dictionary": "дотримуватися",
    "lesson": "16"
  },
  {
    "word": "flat",
    "word_context": "roof",
    "translat": "плоский",
    "translat_context": "дах",
    "dictionary": "плоский",
    "lesson": "16"
  },
  {
    "word": "skin",
    "word_context": "color",
    "translat": "шкіри",
    "translat_context": "колір",
    "dictionary": "шкіра",
    "lesson": "16"
  },
  {
    "word": "important",
    "word_context": "decision",
    "translat": "важливе",
    "translat_context": "рішення",
    "dictionary": "важливий",
    "lesson": "16"
  },
  {
    "word": "hole",
    "word_context": "in sock",
    "translat": "дірка",
    "translat_context": "в шкарпетці",
    "dictionary": "дірка",
    "lesson": "16"
  },
  {
    "word": "trade",
    "word_context": "agreement",
    "translat": "торгова",
    "translat_context": "угода",
    "dictionary": "торговий",
    "lesson": "16"
  },
  {
    "word": "melody",
    "word_context": "plays",
    "translat": "мелодія",
    "translat_context": "грає",
    "dictionary": "мелодія",
    "lesson": "16"
  },
  {
    "word": "trip",
    "word_context": "abroad",
    "translat": "подорож",
    "translat_context": "за кордон",
    "dictionary": "подорож",
    "lesson": "16"
  },
  {
    "word": "office",
    "word_context": "job",
    "translat": "офісна",
    "translat_context": "робота",
    "dictionary": "офіс",
    "lesson": "16"
  },
  {
    "word": "receive",
    "word_context": "a gift",
    "translat": "отримати",
    "translat_context": "подарунок",
    "dictionary": "отримати",
    "lesson": "16"
  },
  {
    "word": "row",
    "word_context": "of seats",
    "translat": "ряд",
    "translat_context": "сидінь",
    "dictionary": "ряд",
    "lesson": "16"
  },
  {
    "word": "mouth",
    "word_context": "is open",
    "translat": "рот",
    "translat_context": "відкритий",
    "dictionary": "рот",
    "lesson": "16"
  },
  {
    "word": "exact",
    "word_context": "match",
    "translat": "точна",
    "translat_context": "відповідність",
    "dictionary": "точний",
    "lesson": "16"
  },
  {
    "word": "symbol",
    "word_context": "of love",
    "translat": "символ",
    "translat_context": "кохання",
    "dictionary": "символ",
    "lesson": "16"
  },
  {
    "word": "die",
    "word_context": "young",
    "translat": "померти",
    "translat_context": "молодим",
    "dictionary": "померти",
    "lesson": "16"
  },
  {
    "word": "least",
    "word_context": "expected",
    "translat": "найменше",
    "translat_context": "очікуване",
    "dictionary": "найменший",
    "lesson": "16"
  },
  {
    "word": "trouble",
    "word_context": "is coming",
    "translat": "неприємність",
    "translat_context": "наближається",
    "dictionary": "неприємність",
    "lesson": "16"
  },
  {
    "word": "shout",
    "word_context": "loudly",
    "translat": "кричати",
    "translat_context": "гучно",
    "dictionary": "кричати",
    "lesson": "16"
  },
  {
    "word": "except",
    "word_context": "Mondays",
    "translat": "крім",
    "translat_context": "понеділків",
    "dictionary": "крім",
    "lesson": "16"
  },
  {
    "word": "wrote",
    "word_context": "a book",
    "translat": "написав",
    "translat_context": "книгу",
    "dictionary": "написав",
    "lesson": "16"
  },
  {
    "word": "seed",
    "word_context": "planted",
    "translat": "насіння",
    "translat_context": "посіяне",
    "dictionary": "насіння",
    "lesson": "16"
  },
  {
    "word": "tone",
    "word_context": "of voice",
    "translat": "тон",
    "translat_context": "голосу",
    "dictionary": "тон",
    "lesson": "17"
  },
  {
    "word": "join",
    "word_context": "a team",
    "translat": "приєднатися",
    "translat_context": "до команди",
    "dictionary": "приєднатися",
    "lesson": "17"
  },
  {
    "word": "suggest",
    "word_context": "a plan",
    "translat": "запропонувати",
    "translat_context": "план",
    "dictionary": "запропонувати",
    "lesson": "17"
  },
  {
    "word": "clean",
    "word_context": "hands",
    "translat": "чисті",
    "translat_context": "руки",
    "dictionary": "чистий",
    "lesson": "17"
  },
  {
    "word": "break",
    "word_context": "down",
    "translat": "зламатися",
    "translat_context": "",
    "dictionary": "зламатися",
    "lesson": "17"
  },
  {
    "word": "lady",
    "word_context": "in red",
    "translat": "пані",
    "translat_context": "в червоному",
    "dictionary": "пані",
    "lesson": "17"
  },
  {
    "word": "yard",
    "word_context": "fence",
    "translat": "двору",
    "translat_context": "паркан",
    "dictionary": "двір",
    "lesson": "17"
  },
  {
    "word": "rise",
    "word_context": "in prices",
    "translat": "зростання",
    "translat_context": "цін",
    "dictionary": "зростання",
    "lesson": "17"
  },
  {
    "word": "bad",
    "word_context": "news",
    "translat": "погані",
    "translat_context": "новини",
    "dictionary": "поганий",
    "lesson": "17"
  },
  {
    "word": "blow",
    "word_context": "the candle",
    "translat": "задути",
    "translat_context": "свічку",
    "dictionary": "задути",
    "lesson": "17"
  },
  {
    "word": "spill",
    "word_context": "of oil",
    "translat": "розлив",
    "translat_context": "нафти",
    "dictionary": "розлив",
    "lesson": "17"
  },
  {
    "word": "blood",
    "word_context": "on clothes",
    "translat": "кров",
    "translat_context": "на одязі",
    "dictionary": "кров",
    "lesson": "17"
  },
  {
    "word": "touch",
    "word_context": "it",
    "translat": "доторкнися",
    "translat_context": "до цього",
    "dictionary": "доторкнися",
    "lesson": "17"
  },
  {
    "word": "grew",
    "word_context": "fast",
    "translat": "зростав",
    "translat_context": "швидко",
    "dictionary": "зростав",
    "lesson": "17"
  },
  {
    "word": "mug",
    "word_context": "handle",
    "translat": "чашки",
    "translat_context": "ручка",
    "dictionary": "чашка",
    "lesson": "17"
  },
  {
    "word": "mix",
    "word_context": "ingredients",
    "translat": "змішати",
    "translat_context": "інгредієнти",
    "dictionary": "змішати",
    "lesson": "17"
  },
  {
    "word": "team",
    "word_context": "effort",
    "translat": "командна",
    "translat_context": "робота",
    "dictionary": "команда",
    "lesson": "17"
  },
  {
    "word": "wire",
    "word_context": "connection",
    "translat": "дротове",
    "translat_context": "з'єднання",
    "dictionary": "дріт",
    "lesson": "17"
  },
  {
    "word": "cost",
    "word_context": "estimate",
    "translat": "вартості",
    "translat_context": "оцінка",
    "dictionary": "вартість",
    "lesson": "17"
  },
  {
    "word": "lost",
    "word_context": "keys",
    "translat": "загублені",
    "translat_context": "ключі",
    "dictionary": "загублений",
    "lesson": "17"
  },
  {
    "word": "brown",
    "word_context": "coat",
    "translat": "коричневе",
    "translat_context": "пальто",
    "dictionary": "коричневий",
    "lesson": "17"
  },
  {
    "word": "wear",
    "word_context": "shoes",
    "translat": "носити",
    "translat_context": "взуття",
    "dictionary": "носити",
    "lesson": "17"
  },
  {
    "word": "garden",
    "word_context": "tools",
    "translat": "садові",
    "translat_context": "інструменти",
    "dictionary": "сад",
    "lesson": "17"
  },
  {
    "word": "equal",
    "word_context": "rights",
    "translat": "рівні",
    "translat_context": "права",
    "dictionary": "рівноправний",
    "lesson": "17"
  },
  {
    "word": "sent",
    "word_context": "a letter",
    "translat": "надісланий",
    "translat_context": "лист",
    "dictionary": "надісланий",
    "lesson": "17"
  },
  {
    "word": "fell",
    "word_context": "down",
    "translat": "впав",
    "translat_context": "долу",
    "dictionary": "впав",
    "lesson": "17"
  },
  {
    "word": "fit",
    "word_context": "perfectly",
    "translat": "підходить",
    "translat_context": "ідеально",
    "dictionary": "підходить",
    "lesson": "17"
  },
  {
    "word": "flow",
    "word_context": "of water",
    "translat": "потік",
    "translat_context": "води",
    "dictionary": "потік",
    "lesson": "17"
  },
  {
    "word": "fair",
    "word_context": "trade",
    "translat": "справедлива",
    "translat_context": "торгівля",
    "dictionary": "справедливий",
    "lesson": "17"
  },
  {
    "word": "bank",
    "word_context": "account",
    "translat": "банківський",
    "translat_context": "рахунок",
    "dictionary": "банк",
    "lesson": "17"
  },
  {
    "word": "collect",
    "word_context": "stamps",
    "translat": "збирати",
    "translat_context": "марки",
    "dictionary": "збирати",
    "lesson": "17"
  },
  {
    "word": "control",
    "word_context": "panel",
    "translat": "контрольна",
    "translat_context": "панель",
    "dictionary": "контрольний",
    "lesson": "17"
  },
  {
    "word": "decimal",
    "word_context": "point",
    "translat": "десяткова",
    "translat_context": "крапка",
    "dictionary": "десятковий",
    "lesson": "17"
  },
  {
    "word": "woman",
    "word_context": "speaks",
    "translat": "жінка",
    "translat_context": "говорить",
    "dictionary": "жінка",
    "lesson": "17"
  },
  {
    "word": "captain",
    "word_context": "of ship",
    "translat": "капітан",
    "translat_context": "корабля",
    "dictionary": "капітан",
    "lesson": "17"
  },
  {
    "word": "practice",
    "word_context": "daily",
    "translat": "практика",
    "translat_context": "щоденна",
    "dictionary": "практика",
    "lesson": "18"
  },
  {
    "word": "separate",
    "word_context": "rooms",
    "translat": "окремі",
    "translat_context": "кімнати",
    "dictionary": "окремий",
    "lesson": "18"
  },
  {
    "word": "difficult",
    "word_context": "choice",
    "translat": "важкий",
    "translat_context": "вибір",
    "dictionary": "важкий",
    "lesson": "18"
  },
  {
    "word": "doctor",
    "word_context": "arrived",
    "translat": "лікар",
    "translat_context": "прибув",
    "dictionary": "лікар",
    "lesson": "18"
  },
  {
    "word": "please",
    "word_context": "sit",
    "translat": "будь ласка",
    "translat_context": "сідайте",
    "dictionary": "будь ласка",
    "lesson": "18"
  },
  {
    "word": "protect",
    "word_context": "the environment",
    "translat": "захищати",
    "translat_context": "довкілля",
    "dictionary": "захищати",
    "lesson": "18"
  },
  {
    "word": "noon",
    "word_context": "sunlight",
    "translat": "полудневе",
    "translat_context": "сонце",
    "dictionary": "полудень",
    "lesson": "18"
  },
  {
    "word": "locate",
    "word_context": "the key",
    "translat": "знайти",
    "translat_context": "ключ",
    "dictionary": "знайти",
    "lesson": "18"
  },
  {
    "word": "ring",
    "word_context": "of gold",
    "translat": "перстень",
    "translat_context": "золота",
    "dictionary": "перстень",
    "lesson": "18"
  },
  {
    "word": "character",
    "word_context": "trait",
    "translat": "характеру",
    "translat_context": "риса",
    "dictionary": "характер",
    "lesson": "18"
  },
  {
    "word": "insect",
    "word_context": "bite",
    "translat": "комахи",
    "translat_context": "укус",
    "dictionary": "комахa",
    "lesson": "18"
  },
  {
    "word": "caught",
    "word_context": "a fish",
    "translat": "зловив",
    "translat_context": "рибу",
    "dictionary": "зловив",
    "lesson": "18"
  },
  {
    "word": "period",
    "word_context": "of time",
    "translat": "період",
    "translat_context": "часу",
    "dictionary": "період",
    "lesson": "18"
  },
  {
    "word": "indicate",
    "word_context": "a problem",
    "translat": "вказувати",
    "translat_context": "на проблему",
    "dictionary": "вказувати",
    "lesson": "18"
  },
  {
    "word": "radio",
    "word_context": "station",
    "translat": "радіо",
    "translat_context": "станція",
    "dictionary": "радіо",
    "lesson": "18"
  },
  {
    "word": "spoke",
    "word_context": "clearly",
    "translat": "говорив",
    "translat_context": "чітко",
    "dictionary": "говорив",
    "lesson": "18"
  },
  {
    "word": "little",
    "word_context": "mouse",
    "translat": "маленька",
    "translat_context": "миша",
    "dictionary": "маленький",
    "lesson": "18"
  },
  {
    "word": "human",
    "word_context": "rights",
    "translat": "людини",
    "translat_context": "права",
    "dictionary": "людина",
    "lesson": "18"
  },
  {
    "word": "history",
    "word_context": "lesson",
    "translat": "історії",
    "translat_context": "урок",
    "dictionary": "історія",
    "lesson": "18"
  },
  {
    "word": "effect",
    "word_context": "was strong",
    "translat": "ефект",
    "translat_context": "був сильним",
    "dictionary": "ефект",
    "lesson": "18"
  },
  {
    "word": "electric",
    "word_context": "charge",
    "translat": "електричний",
    "translat_context": "заряд",
    "dictionary": "електричний",
    "lesson": "18"
  },
  {
    "word": "expect",
    "word_context": "a call",
    "translat": "чекати",
    "translat_context": "дзвінка",
    "dictionary": "чекати",
    "lesson": "18"
  },
  {
    "word": "crop",
    "word_context": "failure",
    "translat": "врожай",
    "translat_context": "не вдався",
    "dictionary": "врожай",
    "lesson": "18"
  },
  {
    "word": "modern",
    "word_context": "design",
    "translat": "сучасний",
    "translat_context": "дизайн",
    "dictionary": "сучасний",
    "lesson": "18"
  },
  {
    "word": "element",
    "word_context": "of surprise",
    "translat": "елемент",
    "translat_context": "сюрпризу",
    "dictionary": "елемент",
    "lesson": "18"
  },
  {
    "word": "hit",
    "word_context": "him hard",
    "translat": "вдар",
    "translat_context": "його сильно",
    "dictionary": "вдарити",
    "lesson": "18"
  },
  {
    "word": "student",
    "word_context": "group",
    "translat": "студентів",
    "translat_context": "група",
    "dictionary": "студент",
    "lesson": "18"
  },
  {
    "word": "corner",
    "word_context": "office",
    "translat": "кутовий",
    "translat_context": "кабінет",
    "dictionary": "кут",
    "lesson": "18"
  },
  {
    "word": "party",
    "word_context": "time",
    "translat": "вечірки",
    "translat_context": "час",
    "dictionary": "вечірка",
    "lesson": "18"
  },
  {
    "word": "supply",
    "word_context": "chain",
    "translat": "постачання",
    "translat_context": "ланцюг",
    "dictionary": "постачання",
    "lesson": "18"
  },
  {
    "word": "bone",
    "word_context": "is broken",
    "translat": "кістка",
    "translat_context": "зламана",
    "dictionary": "кістка",
    "lesson": "18"
  },
  {
    "word": "rail",
    "word_context": "track",
    "translat": "залізнична",
    "translat_context": "колія",
    "dictionary": "залізничний",
    "lesson": "18"
  },
  {
    "word": "imagine",
    "word_context": "a world",
    "translat": "уявити",
    "translat_context": "світ",
    "dictionary": "уявити",
    "lesson": "18"
  },
  {
    "word": "provide",
    "word_context": "help",
    "translat": "надавати",
    "translat_context": "допомогу",
    "dictionary": "надавати",
    "lesson": "18"
  },
  {
    "word": "agree",
    "word_context": "completely",
    "translat": "погоджуватися",
    "translat_context": "повністю",
    "dictionary": "погоджуватися",
    "lesson": "18"
  },
  {
    "word": "capital",
    "word_context": "city",
    "translat": "столиця",
    "translat_context": "міста",
    "dictionary": "столиця",
    "lesson": "19"
  },
  {
    "word": "chair",
    "word_context": "is empty",
    "translat": "стілець",
    "translat_context": "порожній",
    "dictionary": "стілець",
    "lesson": "19"
  },
  {
    "word": "danger",
    "word_context": "zone",
    "translat": "небезпечна",
    "translat_context": "зона",
    "dictionary": "небезпека",
    "lesson": "19"
  },
  {
    "word": "fruit",
    "word_context": "basket",
    "translat": "фруктів",
    "translat_context": "кошик",
    "dictionary": "фрукт",
    "lesson": "19"
  },
  {
    "word": "rich",
    "word_context": "flavor",
    "translat": "багатий",
    "translat_context": "смак",
    "dictionary": "багатий",
    "lesson": "19"
  },
  {
    "word": "thick",
    "word_context": "walls",
    "translat": "товсті",
    "translat_context": "стіни",
    "dictionary": "товстий",
    "lesson": "19"
  },
  {
    "word": "soldier",
    "word_context": "salutes",
    "translat": "солдат",
    "translat_context": "віддає честь",
    "dictionary": "солдат",
    "lesson": "19"
  },
  {
    "word": "process",
    "word_context": "process",
    "translat": "процес",
    "translat_context": "змін",
    "dictionary": "процес",
    "lesson": "19"
  },
  {
    "word": "operate",
    "word_context": "business",
    "translat": "керувати",
    "translat_context": "бізнесом",
    "dictionary": "керувати",
    "lesson": "19"
  },
  {
    "word": "guess",
    "word_context": "again",
    "translat": "вгадай",
    "translat_context": "знову",
    "dictionary": "вгадувати",
    "lesson": "19"
  },
  {
    "word": "necessary",
    "word_context": "documents",
    "translat": "необхідні",
    "translat_context": "документи",
    "dictionary": "необхідний",
    "lesson": "19"
  },
  {
    "word": "sharp",
    "word_context": "knife",
    "translat": "гострий",
    "translat_context": "ніж",
    "dictionary": "гострий",
    "lesson": "19"
  },
  {
    "word": "wing",
    "word_context": "of bird",
    "translat": "крило",
    "translat_context": "птаха",
    "dictionary": "крило",
    "lesson": "19"
  },
  {
    "word": "create",
    "word_context": "art",
    "translat": "створити",
    "translat_context": "мистецтво",
    "dictionary": "створити",
    "lesson": "19"
  },
  {
    "word": "neighbor",
    "word_context": "next door",
    "translat": "сусід",
    "translat_context": "поруч",
    "dictionary": "сусід",
    "lesson": "19"
  },
  {
    "word": "wash",
    "word_context": "your hands",
    "translat": "мий",
    "translat_context": "руки",
    "dictionary": "мити",
    "lesson": "19"
  },
  {
    "word": "bat",
    "word_context": "in cave",
    "translat": "кажан",
    "translat_context": "у печері",
    "dictionary": "кажан",
    "lesson": "19"
  },
  {
    "word": "crowd",
    "word_context": "cheers",
    "translat": "натовп",
    "translat_context": "аплодує",
    "dictionary": "натовп",
    "lesson": "19"
  },
  {
    "word": "corn",
    "word_context": "field",
    "translat": "кукурудзи",
    "translat_context": "поле",
    "dictionary": "кукурудза",
    "lesson": "19"
  },
  {
    "word": "compare",
    "word_context": "prices",
    "translat": "порівнювати",
    "translat_context": "ціни",
    "dictionary": "порівнювати",
    "lesson": "19"
  },
  {
    "word": "lose",
    "word_context": "weight",
    "translat": "втрачати",
    "translat_context": "вагу",
    "dictionary": "втрачати",
    "lesson": "19"
  },
  {
    "word": "string",
    "word_context": "attached",
    "translat": "струна",
    "translat_context": "прикріплена",
    "dictionary": "струна",
    "lesson": "19"
  },
  {
    "word": "bell",
    "word_context": "rings",
    "translat": "дзвінок",
    "translat_context": "дзвонить",
    "dictionary": "дзвінок",
    "lesson": "19"
  },
  {
    "word": "depend",
    "word_context": "on luck",
    "translat": "залежати",
    "translat_context": "від удачі",
    "dictionary": "залежати",
    "lesson": "19"
  },
  {
    "word": "meat",
    "word_context": "is cooked",
    "translat": "м'ясо",
    "translat_context": "приготоване",
    "dictionary": "м'ясо",
    "lesson": "19"
  },
  {
    "word": "rub",
    "word_context": "gently",
    "translat": "терти",
    "translat_context": "ніжно",
    "dictionary": "терти",
    "lesson": "19"
  },
  {
    "word": "tube",
    "word_context": "station",
    "translat": "метро",
    "translat_context": "станція",
    "dictionary": "метро",
    "lesson": "19"
  },
  {
    "word": "famous",
    "word_context": "actor",
    "translat": "відомий",
    "translat_context": "актор",
    "dictionary": "відомий",
    "lesson": "19"
  },
  {
    "word": "dollar",
    "word_context": "bill",
    "translat": "долара",
    "translat_context": "купюра",
    "dictionary": "долар",
    "lesson": "19"
  },
  {
    "word": "stream",
    "word_context": "flows",
    "translat": "потік",
    "translat_context": "тече",
    "dictionary": "потік",
    "lesson": "19"
  },
  {
    "word": "fear",
    "word_context": "of dark",
    "translat": "страх",
    "translat_context": "темряви",
    "dictionary": "страх",
    "lesson": "19"
  },
  {
    "word": "sight",
    "word_context": "was clear",
    "translat": "зір",
    "translat_context": "був чіткий",
    "dictionary": "зір",
    "lesson": "19"
  },
  {
    "word": "thin",
    "word_context": "ice",
    "translat": "тонкий",
    "translat_context": "лід",
    "dictionary": "тонкий",
    "lesson": "19"
  },
  {
    "word": "movie",
    "word_context": "was great",
    "translat": "фільм",
    "translat_context": "був чудовим",
    "dictionary": "фільм",
    "lesson": "19"
  },
  {
    "word": "planet",
    "word_context": "Earth",
    "translat": "планета",
    "translat_context": "Земля",
    "dictionary": "планета",
    "lesson": "19"
  },
  {
    "word": "hurry",
    "word_context": "up",
    "translat": "поспішай",
    "translat_context": "",
    "dictionary": "поспішати",
    "lesson": "20"
  },
  {
    "word": "chief",
    "word_context": "officer",
    "translat": "головний",
    "translat_context": "офіцер",
    "dictionary": "головний",
    "lesson": "20"
  },
  {
    "word": "colony",
    "word_context": "of ants",
    "translat": "колонія",
    "translat_context": "мурах",
    "dictionary": "колонія",
    "lesson": "20"
  },
  {
    "word": "clock",
    "word_context": "is ticking",
    "translat": "годинник",
    "translat_context": "тикає",
    "dictionary": "годинник",
    "lesson": "20"
  },
  {
    "word": "mine",
    "word_context": "shaft",
    "translat": "шахта",
    "translat_context": "копальні",
    "dictionary": "шахта",
    "lesson": "20"
  },
  {
    "word": "tie",
    "word_context": "to a tree",
    "translat": "прив'язати",
    "translat_context": "до дерева",
    "dictionary": "прив'язувати",
    "lesson": "20"
  },
  {
    "word": "enter",
    "word_context": "the room",
    "translat": "увійти",
    "translat_context": "в кімнату",
    "dictionary": "увійти",
    "lesson": "20"
  },
  {
    "word": "major",
    "word_context": "change",
    "translat": "велика",
    "translat_context": "зміна",
    "dictionary": "великий",
    "lesson": "20"
  },
  {
    "word": "fresh",
    "word_context": "bread",
    "translat": "свіжий",
    "translat_context": "хліб",
    "dictionary": "свіжий",
    "lesson": "20"
  },
  {
    "word": "search",
    "word_context": "engine",
    "translat": "пошукова",
    "translat_context": "система",
    "dictionary": "шукати",
    "lesson": "20"
  },
  {
    "word": "send",
    "word_context": "a message",
    "translat": "надіслати",
    "translat_context": "повідомлення",
    "dictionary": "надсилати",
    "lesson": "20"
  },
  {
    "word": "yellow",
    "word_context": "color",
    "translat": "жовтий",
    "translat_context": "колір",
    "dictionary": "жовтий",
    "lesson": "20"
  },
  {
    "word": "gun",
    "word_context": "shot",
    "translat": "рушниці",
    "translat_context": "постріл",
    "dictionary": "рушниця",
    "lesson": "20"
  },
  {
    "word": "allow",
    "word_context": "access",
    "translat": "дозволити",
    "translat_context": "доступ",
    "dictionary": "дозволяти",
    "lesson": "20"
  },
  {
    "word": "print",
    "word_context": "a document",
    "translat": "друкувати",
    "translat_context": "документ",
    "dictionary": "друкувати",
    "lesson": "20"
  },
  {
    "word": "dead",
    "word_context": "battery",
    "translat": "мертва",
    "translat_context": "батарея",
    "dictionary": "мертвий",
    "lesson": "20"
  },
  {
    "word": "spot",
    "word_context": "the error",
    "translat": "помітити",
    "translat_context": "помилку",
    "dictionary": "помічати",
    "lesson": "20"
  },
  {
    "word": "desert",
    "word_context": "heat",
    "translat": "пустельна",
    "translat_context": "спека",
    "dictionary": "пустеля",
    "lesson": "20"
  },
  {
    "word": "suit",
    "word_context": "and tie",
    "translat": "костюм",
    "translat_context": "і краватка",
    "dictionary": "костюм",
    "lesson": "20"
  },
  {
    "word": "current",
    "word_context": "situation",
    "translat": "поточна",
    "translat_context": "ситуація",
    "dictionary": "поточний",
    "lesson": "20"
  },
  {
    "word": "lift",
    "word_context": "the box",
    "translat": "підняти",
    "translat_context": "коробку",
    "dictionary": "піднімати",
    "lesson": "20"
  },
  {
    "word": "rose",
    "word_context": "is red",
    "translat": "троянда",
    "translat_context": "червона",
    "dictionary": "троянда",
    "lesson": "20"
  },
  {
    "word": "continue",
    "word_context": "working",
    "translat": "продовжуй",
    "translat_context": "працювати",
    "dictionary": "продовжувати",
    "lesson": "20"
  },
  {
    "word": "block",
    "word_context": "diagram",
    "translat": "блок",
    "translat_context": "схема",
    "dictionary": "блок",
    "lesson": "20"
  },
  {
    "word": "chart",
    "word_context": "shows",
    "translat": "діаграма",
    "translat_context": "показує",
    "dictionary": "діаграма",
    "lesson": "20"
  },
  {
    "word": "hat",
    "word_context": "is new",
    "translat": "капелюх",
    "translat_context": "новий",
    "dictionary": "капелюх",
    "lesson": "20"
  },
  {
    "word": "sell",
    "word_context": "products",
    "translat": "продавати",
    "translat_context": "товари",
    "dictionary": "продавати",
    "lesson": "20"
  },
  {
    "word": "success",
    "word_context": "comes",
    "translat": "успіх",
    "translat_context": "настає",
    "dictionary": "успіх",
    "lesson": "20"
  },
  {
    "word": "company",
    "word_context": "name",
    "translat": "компанії",
    "translat_context": "назва",
    "dictionary": "компанія",
    "lesson": "20"
  },
  {
    "word": "new",
    "word_context": "bike",
    "translat": "новий",
    "translat_context": "велосипед",
    "dictionary": "новий",
    "lesson": "20"
  },
  {
    "word": "event",
    "word_context": "today",
    "translat": "подія",
    "translat_context": "сьогодні",
    "dictionary": "подія",
    "lesson": "20"
  },
  {
    "word": "particular",
    "word_context": "case",
    "translat": "конкретний",
    "translat_context": "випадок",
    "dictionary": "конкретний",
    "lesson": "20"
  },
  {
    "word": "deal",
    "word_context": "agreed",
    "translat": "угода",
    "translat_context": "досягнута",
    "dictionary": "угода",
    "lesson": "20"
  },
  {
    "word": "swim",
    "word_context": "well",
    "translat": "плавати",
    "translat_context": "добре",
    "dictionary": "плавати",
    "lesson": "20"
  },
  {
    "word": "term",
    "word_context": "ends",
    "translat": "семестр",
    "translat_context": "завершується",
    "dictionary": "семестр",
    "lesson": "20"
  },
  {
    "word": "opposite",
    "word_context": "direction",
    "translat": "протилежний",
    "translat_context": "напрямок",
    "dictionary": "протилежний",
    "lesson": "21"
  },
  {
    "word": "wife",
    "word_context": "and husband",
    "translat": "дружина",
    "translat_context": "і чоловік",
    "dictionary": "дружина",
    "lesson": "21"
  },
  {
    "word": "shoes",
    "word_context": "are clean",
    "translat": "взуття",
    "translat_context": "чисте",
    "dictionary": "взуття",
    "lesson": "21"
  },
  {
    "word": "shoulder",
    "word_context": "joint",
    "translat": "плечовий",
    "translat_context": "суглоб",
    "dictionary": "плече",
    "lesson": "21"
  },
  {
    "word": "spread",
    "word_context": "butter",
    "translat": "намазувати",
    "translat_context": "масло",
    "dictionary": "намазувати",
    "lesson": "21"
  },
  {
    "word": "arrange",
    "word_context": "the books",
    "translat": "розташувати",
    "translat_context": "книги",
    "dictionary": "розташовувати",
    "lesson": "21"
  },
  {
    "word": "camp",
    "word_context": "fire",
    "translat": "таборове",
    "translat_context": "вогнище",
    "dictionary": "табір",
    "lesson": "21"
  },
  {
    "word": "invent",
    "word_context": "a device",
    "translat": "винайти",
    "translat_context": "пристрій",
    "dictionary": "винайти",
    "lesson": "21"
  },
  {
    "word": "cotton",
    "word_context": "shirt",
    "translat": "бавовняна",
    "translat_context": "сорочка",
    "dictionary": "бавовна",
    "lesson": "21"
  },
  {
    "word": "born",
    "word_context": "in June",
    "translat": "народжений",
    "translat_context": "у червні",
    "dictionary": "народжений",
    "lesson": "21"
  },
  {
    "word": "determine",
    "word_context": "a cause",
    "translat": "визначати",
    "translat_context": "причину",
    "dictionary": "визначати",
    "lesson": "21"
  },
  {
    "word": "quarter",
    "word_context": "of of the year",
    "translat": "четверть",
    "translat_context": "року",
    "dictionary": "четверть",
    "lesson": "21"
  },
  {
    "word": "truck",
    "word_context": "driver",
    "translat": "вантажівки",
    "translat_context": "водій",
    "dictionary": "вантажівка",
    "lesson": "21"
  },
  {
    "word": "noise",
    "word_context": "level",
    "translat": "шуму",
    "translat_context": "рівень",
    "dictionary": "шум",
    "lesson": "21"
  },
  {
    "word": "level",
    "word_context": "surface",
    "translat": "рівень",
    "translat_context": "поверхні",
    "dictionary": "ріень",
    "lesson": "21"
  },
  {
    "word": "chance",
    "word_context": "of rain",
    "translat": "ймовірність",
    "translat_context": "дощу",
    "dictionary": "ймовірність",
    "lesson": "21"
  },
  {
    "word": "gather",
    "word_context": "information",
    "translat": "зібрати",
    "translat_context": "інформацію",
    "dictionary": "збирати",
    "lesson": "21"
  },
  {
    "word": "shop",
    "word_context": "window",
    "translat": "магазину",
    "translat_context": "вітрина",
    "dictionary": "магазин",
    "lesson": "21"
  },
  {
    "word": "stretch",
    "word_context": "time",
    "translat": "розтягнути",
    "translat_context": "час",
    "dictionary": "розтягнути",
    "lesson": "21"
  },
  {
    "word": "throw",
    "word_context": "a ball",
    "translat": "кинути",
    "translat_context": "м'яч",
    "dictionary": "кинути",
    "lesson": "21"
  },
  {
    "word": "shine",
    "word_context": "brightly",
    "translat": "світити",
    "translat_context": "яскраво",
    "dictionary": "світити",
    "lesson": "21"
  },
  {
    "word": "property",
    "word_context": "rights",
    "translat": "власності",
    "translat_context": "права",
    "dictionary": "власність",
    "lesson": "21"
  },
  {
    "word": "column",
    "word_context": "of data",
    "translat": "стовпчик",
    "translat_context": "даних",
    "dictionary": "стовпчик",
    "lesson": "21"
  },
  {
    "word": "phone",
    "word_context": "is ringing",
    "translat": "телефон",
    "translat_context": "дзвонить",
    "dictionary": "телефон",
    "lesson": "21"
  },
  {
    "word": "select",
    "word_context": "a file",
    "translat": "вибрати",
    "translat_context": "файл",
    "dictionary": "вибирати",
    "lesson": "21"
  },
  {
    "word": "wrong",
    "word_context": "answer",
    "translat": "неправильна",
    "translat_context": "відповідь",
    "dictionary": "неправильний",
    "lesson": "21"
  },
  {
    "word": "gray",
    "word_context": "sky",
    "translat": "сіре",
    "translat_context": "небо",
    "dictionary": "сірий",
    "lesson": "21"
  },
  {
    "word": "repeat",
    "word_context": "after me",
    "translat": "повторюй",
    "translat_context": "за мною",
    "dictionary": "повторювати",
    "lesson": "21"
  },
  {
    "word": "require",
    "word_context": "attention",
    "translat": "потребує",
    "translat_context": "уваги",
    "dictionary": "потребувати",
    "lesson": "21"
  },
  {
    "word": "broad",
    "word_context": "view",
    "translat": "широкий",
    "translat_context": "огляд",
    "dictionary": "широкий",
    "lesson": "21"
  },
  {
    "word": "prepare",
    "word_context": "a meal",
    "translat": "приготувати",
    "translat_context": "їжу",
    "dictionary": "готувати",
    "lesson": "21"
  },
  {
    "word": "salt",
    "word_context": "shaker",
    "translat": "солонка",
    "translat_context": "",
    "dictionary": "сіль",
    "lesson": "21"
  },
  {
    "word": "nose",
    "word_context": "is blocked",
    "translat": "ніс",
    "translat_context": "закладений",
    "dictionary": "ніс",
    "lesson": "21"
  },
  {
    "word": "plural",
    "word_context": "form",
    "translat": "множинна",
    "translat_context": "форма",
    "dictionary": "множина",
    "lesson": "21"
  },
  {
    "word": "anger",
    "word_context": "control",
    "translat": "гніву",
    "translat_context": "контроль",
    "dictionary": "гнів",
    "lesson": "21"
  },
  {
    "word": "claim",
    "word_context": "rights",
    "translat": "вимагати",
    "translat_context": "права",
    "dictionary": "вимагати",
    "lesson": "22"
  },
  {
    "word": "continent",
    "word_context": "on the map",
    "translat": "континент",
    "translat_context": "на карті",
    "dictionary": "континент",
    "lesson": "22"
  },
  {
    "word": "sad",
    "word_context": "story",
    "translat": "сумна",
    "translat_context": "історія",
    "dictionary": "сумний",
    "lesson": "22"
  },
  {
    "word": "sugar",
    "word_context": "cube",
    "translat": "цукру",
    "translat_context": "кубик",
    "dictionary": "цукор",
    "lesson": "22"
  },
  {
    "word": "death",
    "word_context": "and life",
    "translat": "смерть",
    "translat_context": "і життя",
    "dictionary": "смерть",
    "lesson": "22"
  },
  {
    "word": "pretty",
    "word_context": "girl",
    "translat": "гарна",
    "translat_context": "дівчина",
    "dictionary": "гарний",
    "lesson": "22"
  },
  {
    "word": "skills",
    "word_context": "level",
    "translat": "навичок",
    "translat_context": "рівень",
    "dictionary": "навички",
    "lesson": "22"
  },
  {
    "word": "women",
    "word_context": "rights",
    "translat": "жінок",
    "translat_context": "права",
    "dictionary": "жінки",
    "lesson": "22"
  },
  {
    "word": "season",
    "word_context": "change",
    "translat": "сезону",
    "translat_context": "зміна",
    "dictionary": "сезон",
    "lesson": "22"
  },
  {
    "word": "solution",
    "word_context": "found",
    "translat": "рішення",
    "translat_context": "знайдено",
    "dictionary": "рішення",
    "lesson": "22"
  },
  {
    "word": "magnet",
    "word_context": "power",
    "translat": "магніту",
    "translat_context": "сила",
    "dictionary": "магніт",
    "lesson": "22"
  },
  {
    "word": "silver",
    "word_context": "ring",
    "translat": "срібна",
    "translat_context": "каблучка",
    "dictionary": "срібний",
    "lesson": "22"
  },
  {
    "word": "thank",
    "word_context": "you",
    "translat": "дякую",
    "translat_context": "тобі",
    "dictionary": "дякувати",
    "lesson": "22"
  },
  {
    "word": "branch",
    "word_context": "of tree",
    "translat": "гілка",
    "translat_context": "дерева",
    "dictionary": "гілка",
    "lesson": "22"
  },
  {
    "word": "match",
    "word_context": "with jacket",
    "translat": "підходить",
    "translat_context": "до куртки",
    "dictionary": "підходить",
    "lesson": "22"
  },
  {
    "word": "rug",
    "word_context": "shop",
    "translat": "килимовий",
    "translat_context": "магазин",
    "dictionary": "килимок",
    "lesson": "22"
  },
  {
    "word": "especially",
    "word_context": "important",
    "translat": "особливо",
    "translat_context": "важливо",
    "dictionary": "особливо",
    "lesson": "22"
  },
  {
    "word": "fig",
    "word_context": "tree",
    "translat": "фігове",
    "translat_context": "дерево",
    "dictionary": "фіга",
    "lesson": "22"
  },
  {
    "word": "afraid",
    "word_context": "of dark",
    "translat": "боїться",
    "translat_context": "темряви",
    "dictionary": "боятися",
    "lesson": "22"
  },
  {
    "word": "huge",
    "word_context": "problem",
    "translat": "величезна",
    "translat_context": "проблема",
    "dictionary": "величезний",
    "lesson": "22"
  },
  {
    "word": "sister",
    "word_context": "is older",
    "translat": "сестра",
    "translat_context": "старша",
    "dictionary": "сестра",
    "lesson": "22"
  },
  {
    "word": "steel",
    "word_context": "beam",
    "translat": "сталевий",
    "translat_context": "балка",
    "dictionary": "сталевий",
    "lesson": "22"
  },
  {
    "word": "discuss",
    "word_context": "the topic",
    "translat": "обговорити",
    "translat_context": "тему",
    "dictionary": "обговорити",
    "lesson": "22"
  },
  {
    "word": "forward",
    "word_context": "movement",
    "translat": "вперед",
    "translat_context": "рух",
    "dictionary": "вперед",
    "lesson": "22"
  },
  {
    "word": "similar",
    "word_context": "words",
    "translat": "схожі",
    "translat_context": "слова",
    "dictionary": "схожий",
    "lesson": "22"
  },
  {
    "word": "guide",
    "word_context": "principle",
    "translat": "направляючий",
    "translat_context": "принцип",
    "dictionary": "направляючий",
    "lesson": "22"
  },
  {
    "word": "experience",
    "word_context": "was great",
    "translat": "досвід",
    "translat_context": "був чудовий",
    "dictionary": "досвід",
    "lesson": "22"
  },
  {
    "word": "score",
    "word_context": "a goal",
    "translat": "забити",
    "translat_context": "гол",
    "dictionary": "забити",
    "lesson": "22"
  },
  {
    "word": "apple",
    "word_context": "pie",
    "translat": "яблучний",
    "translat_context": "пиріг",
    "dictionary": "яблуко",
    "lesson": "22"
  },
  {
    "word": "bought",
    "word_context": "a car",
    "translat": "купив",
    "translat_context": "авто",
    "dictionary": "купив",
    "lesson": "22"
  },
  {
    "word": "teacher",
    "word_context": "of English",
    "translat": "вчитель",
    "translat_context": "англійської",
    "dictionary": "вчитель",
    "lesson": "22"
  },
  {
    "word": "pitch",
    "word_context": "is black",
    "translat": "смола",
    "translat_context": "чорна",
    "dictionary": "смола",
    "lesson": "22"
  },
  {
    "word": "coat",
    "word_context": "sleeve",
    "translat": "пальта",
    "translat_context": "рукав",
    "dictionary": "пальто",
    "lesson": "22"
  },
  {
    "word": "mass",
    "word_context": "destruction",
    "translat": "масове",
    "translat_context": "знищення",
    "dictionary": "маса",
    "lesson": "22"
  },
  {
    "word": "card",
    "word_context": "deck",
    "translat": "карт",
    "translat_context": "колода",
    "dictionary": "карта",
    "lesson": "22"
  },
  {
    "word": "band",
    "word_context": "member",
    "translat": "гурту",
    "translat_context": "член",
    "dictionary": "гурт",
    "lesson": "23"
  },
  {
    "word": "rope",
    "word_context": "swing",
    "translat": "мотузкові",
    "translat_context": "гойдалки",
    "dictionary": "мотузка",
    "lesson": "23"
  },
  {
    "word": "slip",
    "word_context": "on ice",
    "translat": "послизнутися",
    "translat_context": "на льоду",
    "dictionary": "послизнутися",
    "lesson": "23"
  },
  {
    "word": "win",
    "word_context": "the game",
    "translat": "виграти",
    "translat_context": "гру",
    "dictionary": "виграти",
    "lesson": "23"
  },
  {
    "word": "dream",
    "word_context": "job",
    "translat": "мрії",
    "translat_context": "робота",
    "dictionary": "мрія",
    "lesson": "23"
  },
  {
    "word": "evening",
    "word_context": "walk",
    "translat": "вечірня",
    "translat_context": "прогулянка",
    "dictionary": "вечірній",
    "lesson": "23"
  },
  {
    "word": "condition",
    "word_context": "is stable",
    "translat": "стан",
    "translat_context": "стабільний",
    "dictionary": "стан",
    "lesson": "23"
  },
  {
    "word": "feed",
    "word_context": "the dog",
    "translat": "нагодувати",
    "translat_context": "собаку",
    "dictionary": "нагодувати",
    "lesson": "23"
  },
  {
    "word": "tool",
    "word_context": "box",
    "translat": "інструментів",
    "translat_context": "ящик",
    "dictionary": "інструмент",
    "lesson": "23"
  },
  {
    "word": "total",
    "word_context": "amount",
    "translat": "загальна",
    "translat_context": "сума",
    "dictionary": "загальний",
    "lesson": "23"
  },
  {
    "word": "basic",
    "word_context": "skills",
    "translat": "базові",
    "translat_context": "навички",
    "dictionary": "базовий",
    "lesson": "23"
  },
  {
    "word": "smell",
    "word_context": "of food",
    "translat": "запах",
    "translat_context": "їжі",
    "dictionary": "запах",
    "lesson": "23"
  },
  {
    "word": "valley",
    "word_context": "view",
    "translat": "долини",
    "translat_context": "вигляд",
    "dictionary": "долина",
    "lesson": "23"
  },
  {
    "word": "nor",
    "word_context": "he",
    "translat": "ані",
    "translat_context": "він",
    "dictionary": "ані",
    "lesson": "23"
  },
  {
    "word": "seat",
    "word_context": "back",
    "translat": "сидіння",
    "translat_context": "спинка",
    "dictionary": "сидіння",
    "lesson": "23"
  },
  {
    "word": "arrive",
    "word_context": "early",
    "translat": "прибути",
    "translat_context": "завчасно",
    "dictionary": "прибути",
    "lesson": "23"
  },
  {
    "word": "master",
    "word_context": "plan",
    "translat": "головний",
    "translat_context": "план",
    "dictionary": "головний",
    "lesson": "23"
  },
  {
    "word": "track",
    "word_context": "number",
    "translat": "доріжки",
    "translat_context": "номер",
    "dictionary": "доріжка",
    "lesson": "23"
  },
  {
    "word": "parents",
    "word_context": "meeting",
    "translat": "батьківські",
    "translat_context": "збори",
    "dictionary": "батьки",
    "lesson": "23"
  },
  {
    "word": "shore",
    "word_context": "line",
    "translat": "берегова",
    "translat_context": "лінія",
    "dictionary": "берег",
    "lesson": "23"
  },
  {
    "word": "division",
    "word_context": "of tasks",
    "translat": "поділ",
    "translat_context": "завдань",
    "dictionary": "поділ",
    "lesson": "23"
  },
  {
    "word": "sheet",
    "word_context": "of paper",
    "translat": "лист",
    "translat_context": "паперу",
    "dictionary": "лист",
    "lesson": "23"
  },
  {
    "word": "substance",
    "word_context": "use",
    "translat": "речовини",
    "translat_context": "вживання",
    "dictionary": "речовина",
    "lesson": "23"
  },
  {
    "word": "favor",
    "word_context": "a friend",
    "translat": "послуга",
    "translat_context": "другу",
    "dictionary": "послуга",
    "lesson": "23"
  },
  {
    "word": "connect",
    "word_context": "the dots",
    "translat": "з'єднати",
    "translat_context": "крапки",
    "dictionary": "з'єднати",
    "lesson": "23"
  },
  {
    "word": "post",
    "word_context": "office",
    "translat": "поштова",
    "translat_context": "станція",
    "dictionary": "пошта",
    "lesson": "23"
  },
  {
    "word": "spend",
    "word_context": "money",
    "translat": "витратити",
    "translat_context": "гроші",
    "dictionary": "витратити",
    "lesson": "23"
  },
  {
    "word": "ugly",
    "word_context": "building",
    "translat": "потворна",
    "translat_context": "будівля",
    "dictionary": "потворний",
    "lesson": "23"
  },
  {
    "word": "fat",
    "word_context": "content",
    "translat": "жиру",
    "translat_context": "вміст",
    "dictionary": "жир",
    "lesson": "23"
  },
  {
    "word": "glad",
    "word_context": "to help",
    "translat": "радий",
    "translat_context": "допомогти",
    "dictionary": "радий",
    "lesson": "23"
  },
  {
    "word": "original",
    "word_context": "idea",
    "translat": "оригінальна",
    "translat_context": "ідея",
    "dictionary": "оригінальний",
    "lesson": "23"
  },
  {
    "word": "share",
    "word_context": "your thoughts",
    "translat": "поділись",
    "translat_context": "думками",
    "dictionary": "ділитися",
    "lesson": "23"
  },
  {
    "word": "station",
    "word_context": "platform",
    "translat": "станції",
    "translat_context": "платформа",
    "dictionary": "станція",
    "lesson": "23"
  },
  {
    "word": "dad",
    "word_context": "and mom",
    "translat": "тато",
    "translat_context": "і мама",
    "dictionary": "тато",
    "lesson": "23"
  },
  {
    "word": "bread",
    "word_context": "is fresh",
    "translat": "хліб",
    "translat_context": "свіжий",
    "dictionary": "хліб",
    "lesson": "23"
  },
  {
    "word": "charge",
    "word_context": "your phone",
    "translat": "заряди",
    "translat_context": "телефон",
    "dictionary": "заряджати",
    "lesson": "24"
  },
  {
    "word": "proper",
    "word_context": "behavior",
    "translat": "належна",
    "translat_context": "поведінка",
    "dictionary": "належний",
    "lesson": "24"
  },
  {
    "word": "bar",
    "word_context": "of chocolate",
    "translat": "плитка",
    "translat_context": "шоколаду",
    "dictionary": "плитка",
    "lesson": "24"
  },
  {
    "word": "offer",
    "word_context": "help",
    "translat": "запропонувати",
    "translat_context": "допомогу",
    "dictionary": "запропонувати",
    "lesson": "24"
  },
  {
    "word": "understand",
    "word_context": "better",
    "translat": "розумію",
    "translat_context": "краще",
    "dictionary": "розуміти",
    "lesson": "24"
  },
  {
    "word": "slave",
    "word_context": "labor",
    "translat": "рабська",
    "translat_context": "праця",
    "dictionary": "раб",
    "lesson": "24"
  },
  {
    "word": "duck",
    "word_context": "egg",
    "translat": "качине",
    "translat_context": "яйце",
    "dictionary": "качка",
    "lesson": "24"
  },
  {
    "word": "instant",
    "word_context": "reaction",
    "translat": "миттєва",
    "translat_context": "реакція",
    "dictionary": "миттєвий",
    "lesson": "24"
  },
  {
    "word": "market",
    "word_context": "day",
    "translat": "ринковий",
    "translat_context": "день",
    "dictionary": "ринок",
    "lesson": "24"
  },
  {
    "word": "degree",
    "word_context": "of difficulty",
    "translat": "ступінь",
    "translat_context": "складності",
    "dictionary": "ступінь",
    "lesson": "24"
  },
  {
    "word": "populate",
    "word_context": "area",
    "translat": "заселяти",
    "translat_context": "територію",
    "dictionary": "заселяти",
    "lesson": "24"
  },
  {
    "word": "chick",
    "word_context": "hatching",
    "translat": "курча",
    "translat_context": "вилуплюється",
    "dictionary": "курча",
    "lesson": "24"
  },
  {
    "word": "dear",
    "word_context": "friend",
    "translat": "дорогий",
    "translat_context": "друг",
    "dictionary": "дорогий",
    "lesson": "24"
  },
  {
    "word": "enemy",
    "word_context": "forces",
    "translat": "ворожі",
    "translat_context": "сили",
    "dictionary": "ворог",
    "lesson": "24"
  },
  {
    "word": "reply",
    "word_context": "quickly",
    "translat": "відповісти",
    "translat_context": "швидко",
    "dictionary": "відповісти",
    "lesson": "24"
  },
  {
    "word": "drink",
    "word_context": "water",
    "translat": "пити",
    "translat_context": "воду",
    "dictionary": "пити",
    "lesson": "24"
  },
  {
    "word": "occur",
    "word_context": "naturally",
    "translat": "виникати",
    "translat_context": "природно",
    "dictionary": "виникати",
    "lesson": "24"
  },
  {
    "word": "support",
    "word_context": "each other",
    "translat": "підтримка",
    "translat_context": "один одного",
    "dictionary": "підтримка",
    "lesson": "24"
  },
  {
    "word": "speech",
    "word_context": "was great",
    "translat": "промова",
    "translat_context": "була чудова",
    "dictionary": "промова",
    "lesson": "24"
  },
  {
    "word": "nature",
    "word_context": "of things",
    "translat": "природа",
    "translat_context": "речей",
    "dictionary": "природа",
    "lesson": "24"
  },
  {
    "word": "range",
    "word_context": "of choices",
    "translat": "вибір",
    "translat_context": "варіантів",
    "dictionary": "вибір",
    "lesson": "24"
  },
  {
    "word": "steam",
    "word_context": "engine",
    "translat": "паровий",
    "translat_context": "двигун",
    "dictionary": "пара",
    "lesson": "24"
  },
  {
    "word": "motion",
    "word_context": "sensors",
    "translat": "руху",
    "translat_context": "датчики",
    "dictionary": "рух",
    "lesson": "24"
  },
  {
    "word": "path",
    "word_context": "is narrow",
    "translat": "стежка",
    "translat_context": "вузька",
    "dictionary": "стежка",
    "lesson": "24"
  },
  {
    "word": "liquid",
    "word_context": "form",
    "translat": "рідка",
    "translat_context": "форма",
    "dictionary": "рідкий",
    "lesson": "24"
  },
  {
    "word": "log",
    "word_context": "file",
    "translat": "журнал",
    "translat_context": "записів",
    "dictionary": "журнал",
    "lesson": "24"
  },
  {
    "word": "meant",
    "word_context": "as a joke",
    "translat": "малося на увазі",
    "translat_context": "як жарт",
    "dictionary": "малося на увазі",
    "lesson": "24"
  },
  {
    "word": "chase",
    "word_context": "scene",
    "translat": "переслідування",
    "translat_context": "сцена",
    "dictionary": "переслідувати",
    "lesson": "24"
  },
  {
    "word": "teeth",
    "word_context": "brushing",
    "translat": "зубів",
    "translat_context": "чищення",
    "dictionary": "зуби",
    "lesson": "24"
  },
  {
    "word": "shell",
    "word_context": "on beach",
    "translat": "мушля",
    "translat_context": "на пляжі",
    "dictionary": "мушля",
    "lesson": "24"
  },
  {
    "word": "neck",
    "word_context": "muscle",
    "translat": "шийний",
    "translat_context": "м'яз",
    "dictionary": "шия",
    "lesson": "24"
  },
  {
    "word": "smile",
    "word_context": "please",
    "translat": "усміхайся",
    "translat_context": "будь ласка",
    "dictionary": "усміхатися",
    "lesson": "24"
  },
  {
    "word": "bright",
    "word_context": "light",
    "translat": "яскраве",
    "translat_context": "світло",
    "dictionary": "яскравий",
    "lesson": "24"
  },
  {
    "word": "quickly",
    "word_context": "run",
    "translat": "швидко",
    "translat_context": "бігти",
    "dictionary": "швидко",
    "lesson": "24"
  },
  {
    "word": "gift",
    "word_context": "box",
    "translat": "подарункова",
    "translat_context": "коробка",
    "dictionary": "подарунок",
    "lesson": "24"
  },
  {
    "word": "choose",
    "word_context": "a name",
    "translat": "вибрати",
    "translat_context": "ім’я",
    "dictionary": "вибирати",
    "lesson": "25"
  },
  {
    "word": "knowledge",
    "word_context": "is power",
    "translat": "знання",
    "translat_context": "це сила",
    "dictionary": "знання",
    "lesson": "25"
  },
  {
    "word": "easy",
    "word_context": "task",
    "translat": "легке",
    "translat_context": "завдання",
    "dictionary": "легкий",
    "lesson": "25"
  },
  {
    "word": "laugh",
    "word_context": "out loud",
    "translat": "сміятися",
    "translat_context": "вголос",
    "dictionary": "сміятися",
    "lesson": "25"
  },
  {
    "word": "truth",
    "word_context": "revealed",
    "translat": "правда",
    "translat_context": "розкрита",
    "dictionary": "правда",
    "lesson": "25"
  },
  {
    "word": "goal",
    "word_context": "should be clear",
    "translat": "ціль",
    "translat_context": "має бути ясною",
    "dictionary": "ціль",
    "lesson": "25"
  },
  {
    "word": "health",
    "word_context": "condition",
    "translat": "здоров'я",
    "translat_context": "стан",
    "dictionary": "здоров'я",
    "lesson": "25"
  },
  {
    "word": "peace",
    "word_context": "talks",
    "translat": "мирні",
    "translat_context": "переговори",
    "dictionary": "мир",
    "lesson": "25"
  },
  {
    "word": "pride",
    "word_context": "and joy",
    "translat": "гордість",
    "translat_context": "і радість",
    "dictionary": "гордість",
    "lesson": "25"
  },
  {
    "word": "risk",
    "word_context": "factor",
    "translat": "ризику",
    "translat_context": "фактор",
    "dictionary": "ризик",
    "lesson": "25"
  },
  {
    "word": "scene",
    "word_context": "opens",
    "translat": "сцена",
    "translat_context": "починається",
    "dictionary": "сцена",
    "lesson": "25"
  },
  {
    "word": "spark",
    "word_context": "fly",
    "translat": "іскра",
    "translat_context": "летить",
    "dictionary": "іскра",
    "lesson": "25"
  },
  {
    "word": "spirit",
    "word_context": "of hope",
    "translat": "дух",
    "translat_context": "надії",
    "dictionary": "дух",
    "lesson": "25"
  },
  {
    "word": "style",
    "word_context": "of music",
    "translat": "стиль",
    "translat_context": "музики",
    "dictionary": "стиль",
    "lesson": "25"
  },
  {
    "word": "task",
    "word_context": "completed",
    "translat": "завдання",
    "translat_context": "виконане",
    "dictionary": "завдання",
    "lesson": "25"
  },
  {
    "word": "youth",
    "word_context": "program",
    "translat": "молодіжна",
    "translat_context": "програма",
    "dictionary": "молодь",
    "lesson": "25"
  },
  {
    "word": "zone",
    "word_context": "of comfort",
    "translat": "зона",
    "translat_context": "комфорту",
    "dictionary": "зона",
    "lesson": "25"
  },
  {
    "word": "disappear",
    "word_context": "suddenly",
    "translat": "зникнути",
    "translat_context": "раптово",
    "dictionary": "зникнати",
    "lesson": "25"
  },
  {
    "word": "display",
    "word_context": "screen",
    "translat": "екран",
    "translat_context": "показу",
    "dictionary": "екран",
    "lesson": "25"
  },
  {
    "word": "nervous",
    "word_context": "breakdown",
    "translat": "нервовий",
    "translat_context": "зрив",
    "dictionary": "нервовий",
    "lesson": "25"
  },
  {
    "word": "grab",
    "word_context": "a snack",
    "translat": "вхопити",
    "translat_context": "перекус",
    "dictionary": "вхопити",
    "lesson": "25"
  },
  {
    "word": "heal",
    "word_context": "the wound",
    "translat": "залікувати",
    "translat_context": "рану",
    "dictionary": "лікувати",
    "lesson": "25"
  },
  {
    "word": "lean",
    "word_context": "on me",
    "translat": "опертися",
    "translat_context": "на мене",
    "dictionary": "опертися",
    "lesson": "25"
  },
  {
    "word": "leap",
    "word_context": "forward",
    "translat": "стрибок",
    "translat_context": "вперед",
    "dictionary": "стрибати",
    "lesson": "25"
  },
  {
    "word": "relax",
    "word_context": "now",
    "translat": "розслабся",
    "translat_context": "зараз",
    "dictionary": "розслабитися",
    "lesson": "25"
  },
  {
    "word": "reveal",
    "word_context": "the truth",
    "translat": "розкрити",
    "translat_context": "правду",
    "dictionary": "розкривати",
    "lesson": "25"
  },
  {
    "word": "scream",
    "word_context": "loudly",
    "translat": "кричати",
    "translat_context": "голосно",
    "dictionary": "кричати",
    "lesson": "25"
  },
  {
    "word": "button",
    "word_context": "press",
    "translat": "кнопки",
    "translat_context": "натискання",
    "dictionary": "кнопка",
    "lesson": "25"
  },
  {
    "word": "increase",
    "word_context": "speed",
    "translat": "збільшити",
    "translat_context": "швидкість",
    "dictionary": "збільшити",
    "lesson": "25"
  },
  {
    "word": "reduce",
    "word_context": "waste",
    "translat": "зменшити",
    "translat_context": "відходи",
    "dictionary": "зменшити",
    "lesson": "25"
  },
  {
    "word": "steal",
    "word_context": "the gem",
    "translat": "вкрасти",
    "translat_context": "коштовність",
    "dictionary": "вкрасти",
    "lesson": "25"
  },
  {
    "word": "influence",
    "word_context": "group",
    "translat": "впливу",
    "translat_context": "група",
    "dictionary": "вплив",
    "lesson": "25"
  },
  {
    "word": "tap",
    "word_context": "for water",
    "translat": "кран",
    "translat_context": "для води",
    "dictionary": "кран",
    "lesson": "25"
  },
  {
    "word": "trap",
    "word_context": "the mouse",
    "translat": "спіймати",
    "translat_context": "мишку",
    "dictionary": "спіймати",
    "lesson": "25"
  },
  {
    "word": "unwrap",
    "word_context": "the gift",
    "translat": "розгорни",
    "translat_context": "подарунок",
    "dictionary": "розгорнути",
    "lesson": "25"
  },
  {
    "word": "announce",
    "word_context": "news",
    "translat": "оголосити",
    "translat_context": "новини",
    "dictionary": "оголосити",
    "lesson": "26"
  },
  {
    "word": "attract",
    "word_context": "attention",
    "translat": "привернути",
    "translat_context": "увагу",
    "dictionary": "привернути",
    "lesson": "26"
  },
  {
    "word": "balance",
    "word_context": "of interests",
    "translat": "баланс",
    "translat_context": "інтересів",
    "dictionary": "баланс",
    "lesson": "26"
  },
  {
    "word": "convince",
    "word_context": "me",
    "translat": "переконати",
    "translat_context": "мене",
    "dictionary": "переконати",
    "lesson": "26"
  },
  {
    "word": "detect",
    "word_context": "movement",
    "translat": "виявити",
    "translat_context": "рух",
    "dictionary": "виявити",
    "lesson": "26"
  },
  {
    "word": "glance",
    "word_context": "quickly",
    "translat": "поглянути",
    "translat_context": "швидко",
    "dictionary": "поглянути",
    "lesson": "26"
  },
  {
    "word": "introduce",
    "word_context": "yourself",
    "translat": "представити",
    "translat_context": "себе",
    "dictionary": "представити",
    "lesson": "26"
  },
  {
    "word": "kick",
    "word_context": "the ball",
    "translat": "вдарити",
    "translat_context": "м’яч",
    "dictionary": "вдарити",
    "lesson": "26"
  },
  {
    "word": "knock",
    "word_context": "on door",
    "translat": "постукати",
    "translat_context": "у двері",
    "dictionary": "постукати",
    "lesson": "26"
  },
  {
    "word": "lock",
    "word_context": "the door",
    "translat": "замкнути",
    "translat_context": "двері",
    "dictionary": "замкнути",
    "lesson": "26"
  },
  {
    "word": "pack",
    "word_context": "your bag",
    "translat": "спакувати",
    "translat_context": "сумку",
    "dictionary": "спакувати",
    "lesson": "26"
  },
  {
    "word": "way",
    "word_context": "forward",
    "translat": "шлях",
    "translat_context": "уперед",
    "dictionary": "шлях",
    "lesson": "26"
  },
  {
    "word": "predict",
    "word_context": "results",
    "translat": "передбачити",
    "translat_context": "результати",
    "dictionary": "передбачити",
    "lesson": "26"
  },
  {
    "word": "punch",
    "word_context": "hard",
    "translat": "вдарити",
    "translat_context": "сильно",
    "dictionary": "вдарити",
    "lesson": "26"
  },
  {
    "word": "react",
    "word_context": "calmly",
    "translat": "реагувати",
    "translat_context": "спокійно",
    "dictionary": "реагувати",
    "lesson": "26"
  },
  {
    "word": "reflect",
    "word_context": "light",
    "translat": "відбивати",
    "translat_context": "світло",
    "dictionary": "відбивати",
    "lesson": "26"
  },
  {
    "word": "replace",
    "word_context": "the part",
    "translat": "замінити",
    "translat_context": "деталь",
    "dictionary": "замінити",
    "lesson": "26"
  },
  {
    "word": "scratch",
    "word_context": "the itch",
    "translat": "почухати",
    "translat_context": "свербіж",
    "dictionary": "почухати",
    "lesson": "26"
  },
  {
    "word": "shock",
    "word_context": "expression",
    "translat": "шокове",
    "translat_context": "вираження",
    "dictionary": "шок",
    "lesson": "26"
  },
  {
    "word": "stitch",
    "word_context": "line",
    "translat": "шовна",
    "translat_context": "лінія",
    "dictionary": "шов",
    "lesson": "26"
  },
  {
    "word": "suspect",
    "word_context": "a crime",
    "translat": "підозрювати",
    "translat_context": "злочин",
    "dictionary": "підозрювати",
    "lesson": "26"
  },
  {
    "word": "trace",
    "word_context": "route",
    "translat": "відстеження",
    "translat_context": "маршрут",
    "dictionary": "відстежувати",
    "lesson": "26"
  },
  {
    "word": "fade",
    "word_context": "away",
    "translat": "зникати",
    "translat_context": "поступово",
    "dictionary": "зникати",
    "lesson": "26"
  },
  {
    "word": "weak",
    "word_context": "and strong",
    "translat": "слабкий",
    "translat_context": "і сильний",
    "dictionary": "слабкий",
    "lesson": "26"
  },
  {
    "word": "slide",
    "word_context": "down",
    "translat": "сповзти",
    "translat_context": "вниз",
    "dictionary": "сповзати",
    "lesson": "26"
  },
  {
    "word": "cheer",
    "word_context": "the team",
    "translat": "підбадьорити",
    "translat_context": "команду",
    "dictionary": "підбадьорювати",
    "lesson": "26"
  },
  {
    "word": "deliver",
    "word_context": "a package",
    "translat": "доставити",
    "translat_context": "посилку",
    "dictionary": "доставляти",
    "lesson": "26"
  },
  {
    "word": "disagree",
    "word_context": "completely",
    "translat": "не погоджуватися",
    "translat_context": "повністю",
    "dictionary": "не погоджуватися",
    "lesson": "26"
  },
  {
    "word": "discover",
    "word_context": "a secret",
    "translat": "відкрити",
    "translat_context": "таємницю",
    "dictionary": "відкривати",
    "lesson": "26"
  },
  {
    "word": "obey",
    "word_context": "the rules",
    "translat": "підкорятися",
    "translat_context": "правилам",
    "dictionary": "підкорятися",
    "lesson": "26"
  },
  {
    "word": "prefer",
    "word_context": "tea",
    "translat": "надавати перевагу",
    "translat_context": "чаю",
    "dictionary": "надавати перевагу",
    "lesson": "26"
  },
  {
    "word": "regret",
    "word_context": "a decision",
    "translat": "шкодувати",
    "translat_context": "про рішення",
    "dictionary": "шкодувати",
    "lesson": "26"
  },
  {
    "word": "seek",
    "word_context": "help",
    "translat": "шукати",
    "translat_context": "допомогу",
    "dictionary": "шукати",
    "lesson": "26"
  },
  {
    "word": "shake",
    "word_context": "with cold",
    "translat": "тремтіти",
    "translat_context": "від холоду",
    "dictionary": "тремтіти",
    "lesson": "26"
  },
  {
    "word": "strengthen",
    "word_context": "muscles",
    "translat": "зміцнювати",
    "translat_context": "м'язи",
    "dictionary": "зміцнювати",
    "lesson": "26"
  },
  {
    "word": "succeed",
    "word_context": "in life",
    "translat": "досягти успіху",
    "translat_context": "в житті",
    "dictionary": "досягати успіху",
    "lesson": "27"
  },
  {
    "word": "suffer",
    "word_context": "pain",
    "translat": "страждати",
    "translat_context": "від болю",
    "dictionary": "страждати",
    "lesson": "27"
  },
  {
    "word": "sweep",
    "word_context": "the floor",
    "translat": "підмести",
    "translat_context": "підлогу",
    "dictionary": "підмітати",
    "lesson": "27"
  },
  {
    "word": "wander",
    "word_context": "aimlessly",
    "translat": "блукати",
    "translat_context": "безцільно",
    "dictionary": "блукати",
    "lesson": "27"
  },
  {
    "word": "whisper",
    "word_context": "a secret",
    "translat": "шепотіти",
    "translat_context": "таємницю",
    "dictionary": "шепотіти",
    "lesson": "27"
  },
  {
    "word": "shift",
    "word_context": "the focus",
    "translat": "змістити",
    "translat_context": "фокус",
    "dictionary": "змістити",
    "lesson": "27"
  },
  {
    "word": "terrify",
    "word_context": "the kids",
    "translat": "лякати",
    "translat_context": "дітей",
    "dictionary": "лякати",
    "lesson": "27"
  },
  {
    "word": "encourage",
    "word_context": "students",
    "translat": "підтримувати",
    "translat_context": "студентів",
    "dictionary": "підтримувати",
    "lesson": "27"
  },
  {
    "word": "judge",
    "word_context": "fairly",
    "translat": "судити",
    "translat_context": "справедливо",
    "dictionary": "судити",
    "lesson": "27"
  },
  {
    "word": "manage",
    "word_context": "a team",
    "translat": "керувати",
    "translat_context": "командою",
    "dictionary": "керувати",
    "lesson": "27"
  },
  {
    "word": "merge",
    "word_context": "files",
    "translat": "об'єднати",
    "translat_context": "файли",
    "dictionary": "об'єднати",
    "lesson": "27"
  },
  {
    "word": "reserve",
    "word_context": "fund",
    "translat": "резервний",
    "translat_context": "фонд",
    "dictionary": "резерв",
    "lesson": "27"
  },
  {
    "word": "breathe",
    "word_context": "slowly",
    "translat": "дихати",
    "translat_context": "повільно",
    "dictionary": "дихати",
    "lesson": "27"
  },
  {
    "word": "avoid",
    "word_context": "conflict",
    "translat": "уникати",
    "translat_context": "конфлікту",
    "dictionary": "уникати",
    "lesson": "27"
  },
  {
    "word": "commit",
    "word_context": "a crime",
    "translat": "скоїти",
    "translat_context": "злочин",
    "dictionary": "скоїти",
    "lesson": "27"
  },
  {
    "word": "complain",
    "word_context": "loudly",
    "translat": "скаржитися",
    "translat_context": "голосно",
    "dictionary": "скаржитися",
    "lesson": "27"
  },
  {
    "word": "dig",
    "word_context": "a hole",
    "translat": "копати",
    "translat_context": "яму",
    "dictionary": "копати",
    "lesson": "27"
  },
  {
    "word": "fail",
    "word_context": "the test",
    "translat": "зазнати невдачі",
    "translat_context": "на іспиті",
    "dictionary": "зазнати невдачі",
    "lesson": "27"
  },
  {
    "word": "fix",
    "word_context": "the car",
    "translat": "полагодити",
    "translat_context": "авто",
    "dictionary": "полагодити",
    "lesson": "27"
  },
  {
    "word": "gain",
    "word_context": "experience",
    "translat": "отримати",
    "translat_context": "досвід",
    "dictionary": "отримати",
    "lesson": "27"
  },
  {
    "word": "limit",
    "word_context": "access",
    "translat": "обмежити",
    "translat_context": "доступ",
    "dictionary": "обмежувати",
    "lesson": "27"
  },
  {
    "word": "obtain",
    "word_context": "permission",
    "translat": "отримати",
    "translat_context": "дозвіл",
    "dictionary": "отримати",
    "lesson": "27"
  },
  {
    "word": "permit",
    "word_context": "entry",
    "translat": "дозволити",
    "translat_context": "вхід",
    "dictionary": "дозволити",
    "lesson": "27"
  },
  {
    "word": "quit",
    "word_context": "smoking",
    "translat": "перестати",
    "translat_context": "палити",
    "dictionary": "перестати",
    "lesson": "27"
  },
  {
    "word": "repair",
    "word_context": "damage",
    "translat": "відремонтувати",
    "translat_context": "пошкодження",
    "dictionary": "ремонтувати",
    "lesson": "27"
  },
  {
    "word": "skip",
    "word_context": "a step",
    "translat": "пропустити",
    "translat_context": "крок",
    "dictionary": "пропускати",
    "lesson": "27"
  },
  {
    "word": "spin",
    "word_context": "around",
    "translat": "крутитися",
    "translat_context": "навколо",
    "dictionary": "крутитися",
    "lesson": "27"
  },
  {
    "word": "split",
    "word_context": "the bill",
    "translat": "розділити",
    "translat_context": "рахунок",
    "dictionary": "розділити",
    "lesson": "27"
  },
  {
    "word": "spoil",
    "word_context": "the dinner",
    "translat": "зіпсувати",
    "translat_context": "вечерю",
    "dictionary": "зіпсувати",
    "lesson": "27"
  },
  {
    "word": "stain",
    "word_context": "on the shirt",
    "translat": "пляма",
    "translat_context": "на сорочці",
    "dictionary": "пляма",
    "lesson": "27"
  },
  {
    "word": "stir",
    "word_context": "the soup",
    "translat": "перемішати",
    "translat_context": "суп",
    "dictionary": "перемішати",
    "lesson": "27"
  },
  {
    "word": "apply",
    "word_context": "for job",
    "translat": "подати заявку",
    "translat_context": "на роботу",
    "dictionary": "подати заявку",
    "lesson": "27"
  },
  {
    "word": "calm",
    "word_context": "your mind",
    "translat": "заспокоїти",
    "translat_context": "розум",
    "dictionary": "заспокоїти",
    "lesson": "27"
  },
  {
    "word": "fold",
    "word_context": "the paper",
    "translat": "згинати",
    "translat_context": "папір",
    "dictionary": "згинати",
    "lesson": "27"
  },
  {
    "word": "handle",
    "word_context": "pressure",
    "translat": "справлятися",
    "translat_context": "з тиском",
    "dictionary": "справлятися",
    "lesson": "27"
  },
  {
    "word": "install",
    "word_context": "software",
    "translat": "встановити",
    "translat_context": "програму",
    "dictionary": "встановлювати",
    "lesson": "28"
  },
  {
    "word": "melt",
    "word_context": "the ice",
    "translat": "розтопити",
    "translat_context": "лід",
    "dictionary": "розтопити",
    "lesson": "28"
  },
  {
    "word": "rely",
    "word_context": "on luck",
    "translat": "покладатися",
    "translat_context": "на удачу",
    "dictionary": "покладатися",
    "lesson": "28"
  },
  {
    "word": "spill",
    "word_context": "the juice",
    "translat": "пролити",
    "translat_context": "сік",
    "dictionary": "пролити",
    "lesson": "28"
  },
  {
    "word": "struggle",
    "word_context": "hard",
    "translat": "боротися",
    "translat_context": "важко",
    "dictionary": "боротися",
    "lesson": "28"
  },
  {
    "word": "stumble",
    "word_context": "on stone",
    "translat": "спіткнутися",
    "translat_context": "об камінь",
    "dictionary": "спіткнутися",
    "lesson": "28"
  },
  {
    "word": "tackle",
    "word_context": "a problem",
    "translat": "вирішити",
    "translat_context": "проблему",
    "dictionary": "вирішити",
    "lesson": "28"
  },
  {
    "word": "tremble",
    "word_context": "with fear",
    "translat": "тремтіти",
    "translat_context": "від страху",
    "dictionary": "тремтіти",
    "lesson": "28"
  },
  {
    "word": "advance",
    "word_context": "payment",
    "translat": "попередня",
    "translat_context": "оплата",
    "dictionary": "попередній",
    "lesson": "28"
  },
  {
    "word": "yell",
    "word_context": "loudly",
    "translat": "кричати",
    "translat_context": "голосно",
    "dictionary": "кричати",
    "lesson": "28"
  },
  {
    "word": "demand",
    "word_context": "answers",
    "translat": "вимагати",
    "translat_context": "відповідей",
    "dictionary": "вимагати",
    "lesson": "28"
  },
  {
    "word": "deny",
    "word_context": "the truth",
    "translat": "заперечувати",
    "translat_context": "правду",
    "dictionary": "заперечувати",
    "lesson": "28"
  },
  {
    "word": "examine",
    "word_context": "carefully",
    "translat": "перевіряти",
    "translat_context": "ретельно",
    "dictionary": "перевіряти",
    "lesson": "28"
  },
  {
    "word": "expand",
    "word_context": "the business",
    "translat": "розширити",
    "translat_context": "бізнес",
    "dictionary": "розширювати",
    "lesson": "28"
  },
  {
    "word": "hang",
    "word_context": "a picture",
    "translat": "повісити",
    "translat_context": "картину",
    "dictionary": "вішати",
    "lesson": "28"
  },
  {
    "word": "intend",
    "word_context": "to stay",
    "translat": "мати намір",
    "translat_context": "залишитись",
    "dictionary": "мати намір",
    "lesson": "28"
  },
  {
    "word": "lend",
    "word_context": "money",
    "translat": "позичити",
    "translat_context": "гроші",
    "dictionary": "позичити",
    "lesson": "28"
  },
  {
    "word": "link",
    "word_context": "accounts",
    "translat": "зв'язати",
    "translat_context": "акаунти",
    "dictionary": "зв'язувати",
    "lesson": "28"
  },
  {
    "word": "down",
    "word_context": "stairs",
    "translat": "внизу",
    "translat_context": "(на першому поверсі)",
    "dictionary": "вниз",
    "lesson": "28"
  },
  {
    "word": "present",
    "word_context": "a project",
    "translat": "представити",
    "translat_context": "проект",
    "dictionary": "представити",
    "lesson": "28"
  },
  {
    "word": "prevent",
    "word_context": "injuries",
    "translat": "запобігти",
    "translat_context": "травмам",
    "dictionary": "запобігти",
    "lesson": "28"
  },
  {
    "word": "remind",
    "word_context": "me later",
    "translat": "нагадати",
    "translat_context": "пізніше",
    "dictionary": "нагадувати",
    "lesson": "28"
  },
  {
    "word": "respond",
    "word_context": "quickly",
    "translat": "відповісти",
    "translat_context": "швидко",
    "dictionary": "відповідати",
    "lesson": "28"
  },
  {
    "word": "sink",
    "word_context": "in water",
    "translat": "тонути",
    "translat_context": "у воді",
    "dictionary": "тонути",
    "lesson": "28"
  },
  {
    "word": "surround",
    "word_context": "the area",
    "translat": "оточити",
    "translat_context": "територію",
    "dictionary": "оточувати",
    "lesson": "28"
  },
  {
    "word": "swing",
    "word_context": "the bat",
    "translat": "махнути",
    "translat_context": "битою",
    "dictionary": "махати",
    "lesson": "28"
  },
  {
    "word": "destroy",
    "word_context": "evidence",
    "translat": "знищити",
    "translat_context": "докази",
    "dictionary": "знищувати",
    "lesson": "28"
  },
  {
    "word": "employ",
    "word_context": "staff",
    "translat": "найняти",
    "translat_context": "персонал",
    "dictionary": "наймати",
    "lesson": "28"
  },
  {
    "word": "enjoy",
    "word_context": "the meal",
    "translat": "насолоджуватися",
    "translat_context": "їжею",
    "dictionary": "насолоджуватися",
    "lesson": "28"
  },
  {
    "word": "jog",
    "word_context": "in park",
    "translat": "бігти підтюпцем",
    "translat_context": "у парку",
    "dictionary": "бігти (підтюпцем)",
    "lesson": "28"
  },
  {
    "word": "mention",
    "word_context": "her name",
    "translat": "згадати",
    "translat_context": "її ім’я",
    "dictionary": "згадувати",
    "lesson": "28"
  },
  {
    "word": "swallow",
    "word_context": "a pill",
    "translat": "проковтнути",
    "translat_context": "таблетку",
    "dictionary": "ковтати",
    "lesson": "28"
  },
  {
    "word": "accept",
    "word_context": "an offer",
    "translat": "прийняти",
    "translat_context": "пропозицію",
    "dictionary": "приймати",
    "lesson": "28"
  },
  {
    "word": "adapt",
    "word_context": "quickly",
    "translat": "адаптуватися",
    "translat_context": "швидко",
    "dictionary": "адаптуватися",
    "lesson": "28"
  },
  {
    "word": "escape",
    "word_context": "from prison",
    "translat": "втекти",
    "translat_context": "з в'язниці",
    "dictionary": "втекти",
    "lesson": "28"
  },
  {
    "word": "tempt",
    "word_context": "fate",
    "translat": "спокушати",
    "translat_context": "долю",
    "dictionary": "спокушати",
    "lesson": "29"
  },
  {
    "word": "wipe",
    "word_context": "the table",
    "translat": "витерти",
    "translat_context": "стіл",
    "dictionary": "витирати",
    "lesson": "29"
  },
  {
    "word": "admire",
    "word_context": "her work",
    "translat": "захоплюватися",
    "translat_context": "її роботою",
    "dictionary": "захоплюватися",
    "lesson": "29"
  },
  {
    "word": "comfort",
    "word_context": "a friend",
    "translat": "втішати",
    "translat_context": "друга",
    "dictionary": "втішати",
    "lesson": "29"
  },
  {
    "word": "patience",
    "word_context": "limit",
    "translat": "терпіння",
    "translat_context": "межа",
    "dictionary": "терпіння",
    "lesson": "29"
  },
  {
    "word": "earn",
    "word_context": "money",
    "translat": "заробити",
    "translat_context": "гроші",
    "dictionary": "заробляти",
    "lesson": "29"
  },
  {
    "word": "incredible",
    "word_context": "experience",
    "translat": "неймовірний",
    "translat_context": "досвід",
    "dictionary": "неймовірний",
    "lesson": "29"
  },
  {
    "word": "explore",
    "word_context": "the cave",
    "translat": "досліджувати",
    "translat_context": "печеру",
    "dictionary": "досліджувати",
    "lesson": "29"
  },
  {
    "word": "guard",
    "word_context": "the gate",
    "translat": "охороняти",
    "translat_context": "ворота",
    "dictionary": "охороняти",
    "lesson": "29"
  },
  {
    "word": "harm",
    "word_context": "the environment",
    "translat": "шкодити",
    "translat_context": "довкіллю",
    "dictionary": "шкодити",
    "lesson": "29"
  },
  {
    "word": "ignore",
    "word_context": "the call",
    "translat": "ігнорувати",
    "translat_context": "виклик",
    "dictionary": "ігнорувати",
    "lesson": "29"
  },
  {
    "word": "inform",
    "word_context": "the team",
    "translat": "повідомити",
    "translat_context": "команду",
    "dictionary": "повідомляти",
    "lesson": "29"
  },
  {
    "word": "injure",
    "word_context": "a leg",
    "translat": "пошкодити",
    "translat_context": "ногу",
    "dictionary": "пошкодити",
    "lesson": "29"
  },
  {
    "word": "inspire",
    "word_context": "others",
    "translat": "надихати",
    "translat_context": "інших",
    "dictionary": "надихати",
    "lesson": "29"
  },
  {
    "word": "marry",
    "word_context": "young",
    "translat": "одружитися",
    "translat_context": "молодим",
    "dictionary": "одружуватися",
    "lesson": "29"
  },
  {
    "word": "perform",
    "word_context": "duty",
    "translat": "виконувати",
    "translat_context": "обов'язки",
    "dictionary": "виконувати",
    "lesson": "29"
  },
  {
    "word": "restore",
    "word_context": "order",
    "translat": "відновити",
    "translat_context": "порядок",
    "dictionary": "відновлювати",
    "lesson": "29"
  },
  {
    "word": "retire",
    "word_context": "early",
    "translat": "піти у відставку",
    "translat_context": "рано",
    "dictionary": "піти у відставку",
    "lesson": "29"
  },
  {
    "word": "reward",
    "word_context": "effort",
    "translat": "винагородити",
    "translat_context": "зусилля",
    "dictionary": "винагородити",
    "lesson": "29"
  },
  {
    "word": "scare",
    "word_context": "children",
    "translat": "налякати",
    "translat_context": "дітей",
    "dictionary": "лякати",
    "lesson": "29"
  },
  {
    "word": "sort",
    "word_context": "by size",
    "translat": "сортувати",
    "translat_context": "за розміром",
    "dictionary": "сортувати",
    "lesson": "29"
  },
  {
    "word": "warn",
    "word_context": "about danger",
    "translat": "попередити",
    "translat_context": "про небезпеку",
    "dictionary": "попереджувати",
    "lesson": "29"
  },
  {
    "word": "worry",
    "word_context": "too much",
    "translat": "турбуватися",
    "translat_context": "занадто сильно",
    "dictionary": "турбуватися",
    "lesson": "29"
  },
  {
    "word": "alert",
    "word_context": "message",
    "translat": "тривожне",
    "translat_context": "повідомлення",
    "dictionary": "тривожний",
    "lesson": "29"
  },
  {
    "word": "advise",
    "word_context": "carefully",
    "translat": "радити",
    "translat_context": "обережно",
    "dictionary": "радити",
    "lesson": "29"
  },
  {
    "word": "assist",
    "word_context": "the patient",
    "translat": "допомогти",
    "translat_context": "пацієнту",
    "dictionary": "допомогати",
    "lesson": "29"
  },
  {
    "word": "confuse",
    "word_context": "the facts",
    "translat": "плутати",
    "translat_context": "факти",
    "dictionary": "плутати",
    "lesson": "29"
  },
  {
    "word": "express",
    "word_context": "your feelings",
    "translat": "висловити",
    "translat_context": "почуття",
    "dictionary": "висловлювати",
    "lesson": "29"
  },
  {
    "word": "impress",
    "word_context": "the judge",
    "translat": "вразити",
    "translat_context": "суддю",
    "dictionary": "вразити",
    "lesson": "29"
  },
  {
    "word": "kiss",
    "word_context": "goodbye",
    "translat": "поцілувати",
    "translat_context": "на прощання",
    "dictionary": "цілувати",
    "lesson": "29"
  },
  {
    "word": "pause",
    "word_context": "the video",
    "translat": "призупинити",
    "translat_context": "відео",
    "dictionary": "призупинити",
    "lesson": "29"
  },
  {
    "word": "praise",
    "word_context": "for the effort",
    "translat": "похвалити",
    "translat_context": "за зусилля",
    "dictionary": "хвалити",
    "lesson": "29"
  },
  {
    "word": "promise",
    "word_context": "to help",
    "translat": "пообіцяти",
    "translat_context": "допомогти",
    "dictionary": "обіцяти",
    "lesson": "29"
  },
  {
    "word": "publish",
    "word_context": "a book",
    "translat": "опублікувати",
    "translat_context": "книгу",
    "dictionary": "публікувати",
    "lesson": "29"
  },
  {
    "word": "punish",
    "word_context": "the child",
    "translat": "покарати",
    "translat_context": "дитину",
    "dictionary": "карати",
    "lesson": "29"
  },
  {
    "word": "refuse",
    "word_context": "the offer",
    "translat": "відмовитися",
    "translat_context": "від пропозиції",
    "dictionary": "відмовлятися",
    "lesson": "30"
  },
  {
    "word": "release",
    "word_context": "the bird",
    "translat": "відпустити",
    "translat_context": "пташку",
    "dictionary": "відпускати",
    "lesson": "30"
  },
  {
    "word": "resist",
    "word_context": "temptation",
    "translat": "протистояти",
    "translat_context": "спокусі",
    "dictionary": "протистояти",
    "lesson": "30"
  },
  {
    "word": "rush",
    "word_context": "to work",
    "translat": "поспішати",
    "translat_context": "на роботу",
    "dictionary": "поспішати",
    "lesson": "30"
  },
  {
    "word": "smash",
    "word_context": "the glass",
    "translat": "розбити",
    "translat_context": "скло",
    "dictionary": "розбити",
    "lesson": "30"
  },
  {
    "word": "tease",
    "word_context": "the cat",
    "translat": "дражнити",
    "translat_context": "кота",
    "dictionary": "дражнити",
    "lesson": "30"
  },
  {
    "word": "remain",
    "word_context": "calm",
    "translat": "залишатися",
    "translat_context": "спокійним",
    "dictionary": "залишатися",
    "lesson": "30"
  },
  {
    "word": "trust",
    "word_context": "your instincts",
    "translat": "довіряти",
    "translat_context": "інстинктам",
    "dictionary": "довіряти",
    "lesson": "30"
  },
  {
    "word": "twist",
    "word_context": "an ankle",
    "translat": "вивихнути",
    "translat_context": "щиколотку",
    "dictionary": "вивихнути",
    "lesson": "30"
  },
  {
    "word": "celebrate",
    "word_context": "a birthday",
    "translat": "святкувати",
    "translat_context": "день народження",
    "dictionary": "святкувати",
    "lesson": "30"
  },
  {
    "word": "compete",
    "word_context": "in race",
    "translat": "змагатися",
    "translat_context": "в гонці",
    "dictionary": "змагатися",
    "lesson": "30"
  },
  {
    "word": "concentrate",
    "word_context": "hard",
    "translat": "зосередитися",
    "translat_context": "ретельно",
    "dictionary": "зосередитися",
    "lesson": "30"
  },
  {
    "word": "educate",
    "word_context": "children",
    "translat": "навчати",
    "translat_context": "дітей",
    "dictionary": "навчати",
    "lesson": "30"
  },
  {
    "word": "invite",
    "word_context": "friends",
    "translat": "запросити",
    "translat_context": "друзів",
    "dictionary": "запросити",
    "lesson": "30"
  },
  {
    "word": "taste",
    "word_context": "the soup",
    "translat": "спробувати",
    "translat_context": "суп",
    "dictionary": "пробувати",
    "lesson": "30"
  },
  {
    "word": "argue",
    "word_context": "a point",
    "translat": "сперечатися",
    "translat_context": "з приводу",
    "dictionary": "сперечатися",
    "lesson": "30"
  },
  {
    "word": "focus",
    "word_context": "attention",
    "translat": "зосередити",
    "translat_context": "увагу",
    "dictionary": "зосередити",
    "lesson": "30"
  },
  {
    "word": "hug",
    "word_context": "tightly",
    "translat": "обіймати",
    "translat_context": "міцно",
    "dictionary": "обіймати",
    "lesson": "30"
  },
  {
    "word": "rumor",
    "word_context": "spread",
    "translat": "чутка",
    "translat_context": "поширилася",
    "dictionary": "чутка",
    "lesson": "30"
  },
  {
    "word": "pour",
    "word_context": "some tea",
    "translat": "налити",
    "translat_context": "чаю",
    "dictionary": "налити",
    "lesson": "30"
  },
  {
    "word": "pursue",
    "word_context": "a goal",
    "translat": "переслідувати",
    "translat_context": "мету",
    "dictionary": "переслідувати",
    "lesson": "30"
  },
  {
    "word": "rescue",
    "word_context": "the dog",
    "translat": "врятувати",
    "translat_context": "собаку",
    "dictionary": "рятувати",
    "lesson": "30"
  },
  {
    "word": "shrug",
    "word_context": "your shoulders",
    "translat": "знизати",
    "translat_context": "плечима",
    "dictionary": "знизувати",
    "lesson": "30"
  },
  {
    "word": "deserve",
    "word_context": "respect",
    "translat": "заслуговувати",
    "translat_context": "на повагу",
    "dictionary": "заслуговувати",
    "lesson": "30"
  },
  {
    "word": "dive",
    "word_context": "into water",
    "translat": "пірнути",
    "translat_context": "у воду",
    "dictionary": "пірнути",
    "lesson": "30"
  },
  {
    "word": "forgive",
    "word_context": "mistakes",
    "translat": "пробачити",
    "translat_context": "помилки",
    "dictionary": "пробачати",
    "lesson": "30"
  },
  {
    "word": "save",
    "word_context": "a life",
    "translat": "врятувати",
    "translat_context": "життя",
    "dictionary": "рятувати",
    "lesson": "30"
  },
  {
    "word": "survive",
    "word_context": "a crash",
    "translat": "вижити",
    "translat_context": "в аварії",
    "dictionary": "виживати",
    "lesson": "30"
  },
  {
    "word": "active",
    "word_context": "lifestyle",
    "translat": "активний",
    "translat_context": "спосіб життя",
    "dictionary": "активний",
    "lesson": "30"
  },
  {
    "word": "crawl",
    "word_context": "slowly",
    "translat": "повзти",
    "translat_context": "повільно",
    "dictionary": "повзти",
    "lesson": "30"
  },
  {
    "word": "yawn",
    "word_context": "loudly",
    "translat": "позіхати",
    "translat_context": "голосно",
    "dictionary": "позіхати",
    "lesson": "30"
  },
  {
    "word": "amazing",
    "word_context": "story",
    "translat": "дивовижна",
    "translat_context": "історія",
    "dictionary": "дивовижний",
    "lesson": "30"
  },
  {
    "word": "freeze",
    "word_context": "the food",
    "translat": "заморозити",
    "translat_context": "продукти",
    "dictionary": "заморозити",
    "lesson": "30"
  },
  {
    "word": "realize",
    "word_context": "the truth",
    "translat": "усвідомити",
    "translat_context": "правду",
    "dictionary": "усвідомлювати",
    "lesson": "30"
  },
  {
    "word": "squeeze",
    "word_context": "the lemon",
    "translat": "вичавити",
    "translat_context": "лимон",
    "dictionary": "вичавлювати",
    "lesson": "30"
  }
];
